import { defineComponent, ref, computed, watch, unref, onScopeDispose, reactive, readonly, onMounted, onUnmounted, nextTick } from 'vue';

//

var script$N = defineComponent({
  name: "DsAccordion",
  props: {
    ariaLabel: String,
  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$N = script$N;

/* template */
var __vue_render__$N = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ul",
    { staticClass: "ds-accordion", attrs: { "aria-label": _vm.ariaLabel } },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$N = [];
__vue_render__$N._withStripped = true;

  /* style */
  const __vue_inject_styles__$N = undefined;
  /* scoped */
  const __vue_scope_id__$N = undefined;
  /* module identifier */
  const __vue_module_identifier__$N = undefined;
  /* functional template */
  const __vue_is_functional_template__$N = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$N = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$N, staticRenderFns: __vue_staticRenderFns__$N },
    __vue_inject_styles__$N,
    __vue_script__$N,
    __vue_scope_id__$N,
    __vue_is_functional_template__$N,
    __vue_module_identifier__$N,
    false,
    undefined,
    undefined,
    undefined
  );

const isUrl = (checkUrl) => {
    let url;
    try {
        url = new URL(checkUrl);
    }
    catch (e) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
};
const noop = () => { };
const hasWindow = () => {
    return typeof window !== 'undefined';
};
const hasDocument = () => {
    return typeof document !== 'undefined';
};
const getNameForDifficulty = (difficulty) => {
    switch (difficulty) {
        case 1:
            return 'simpel';
        case 2:
            return 'normal';
        case 3:
            return 'pfiffig';
        default:
            return 'n/a';
    }
};
const highlightSuggestion = (word, highlight, tag = 'em') => {
    const searchRegex = new RegExp(highlight, 'i');
    if (word) {
        return word.replace(searchRegex, `<${tag}>$&</${tag}>`);
    }
    return word;
};
const formatNiceDate = (dateString) => {
    const now = new Date();
    const pastDate = new Date(dateString);
    if (!(pastDate instanceof Date) || isNaN(pastDate.getTime())) {
        throw "invalid input";
    }
    const diff = now.getTime() - pastDate.getTime();
    const diffInHours = Math.floor(diff / (1000 * 3600));
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays === 0) {
        if (diffInHours === 0) {
            return `vor wenigen Minuten`;
        }
        return `vor ${diffInHours} Stunde${diffInHours === 1 ? '' : 'n'}`;
    }
    if (diffInDays === 1) {
        return 'vor 1 Tag';
    }
    if (diffInDays < 7) {
        return `vor ${diffInDays} Tagen`;
    }
    if (diffInDays < 28) {
        const weeks = Math.round(diffInDays / 7);
        return `vor ${weeks} Woche${weeks === 1 ? '' : 'n'}`;
    }
    if (diffInDays < 365) {
        const months = Math.round(diffInDays / 30);
        return `vor ${months} Monat${months === 1 ? '' : 'en'}`;
    }
    const years = Math.round(diffInDays / 365);
    return `vor ${years} Jahr${years === 1 ? '' : 'en'}`;
};
const uuid = () => {
    return Date.now().toString(36) + Math.random().toString(36);
};

var script$M = defineComponent({
    name: "DsAccordionItem",
    props: {
        title: {
            type: String,
            required: true,
        },
        isExpanded: {
            type: Boolean,
            default: false
        }
    },
    emits: ['onToggle'],
    setup(props, { emit }) {
        const expanded = ref(props.isExpanded);
        const id = uuid();
        const buttonId = `accordion-button-${id}`;
        const contentId = `accordion-content-${id}`;
        const onToggle = (e) => {
            emit('onToggle', e);
            expanded.value = !expanded.value;
        };
        return {
            buttonId,
            contentId,
            expanded,
            id,
            onToggle,
        };
    },
});

/* script */
const __vue_script__$M = script$M;

/* template */
var __vue_render__$M = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "li",
    {
      key: _vm.id,
      staticClass: "ds-accordion__item",
      class: { "ds-accordion__item--active": _vm.expanded },
    },
    [
      _c(
        "button",
        {
          staticClass: "ds-accordion__btn ds-text-sans ds-h4",
          attrs: {
            "aria-expanded": _vm.expanded ? "true" : "false",
            id: _vm.buttonId,
            "aria-controls": _vm.contentId,
          },
          on: { click: _vm.onToggle },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.title)),
          _c("i", { staticClass: "ds-accordion__btn-icon chefkoch-icons" }, [
            _vm._v(""),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ds-accordion__content",
          attrs: {
            "aria-hidden": _vm.expanded ? "false" : "true",
            id: _vm.contentId,
          },
        },
        [
          _c(
            "div",
            { staticClass: "ds-accordion__inner" },
            [_vm._t("default")],
            2
          ),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$M = [];
__vue_render__$M._withStripped = true;

  /* style */
  const __vue_inject_styles__$M = undefined;
  /* scoped */
  const __vue_scope_id__$M = undefined;
  /* module identifier */
  const __vue_module_identifier__$M = undefined;
  /* functional template */
  const __vue_is_functional_template__$M = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$M = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$M, staticRenderFns: __vue_staticRenderFns__$M },
    __vue_inject_styles__$M,
    __vue_script__$M,
    __vue_scope_id__$M,
    __vue_is_functional_template__$M,
    __vue_module_identifier__$M,
    false,
    undefined,
    undefined,
    undefined
  );

var script$L = defineComponent({
    name: "DsPlusBadge",
    props: {
        mobileSmall: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const classes = computed(() => `${props.mobileSmall && !props.small ? 'ds-plus-badge--mobile-small' : ''}${props.small ? 'ds-plus-badge--small' : ''}`);
        return {
            classes,
        };
    },
});

/* script */
const __vue_script__$L = script$L;

/* template */
var __vue_render__$L = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ds-plus-badge",
    class: _vm.classes,
    attrs: { role: "img", "aria-label": "Chefkoch PLUS" },
  })
};
var __vue_staticRenderFns__$L = [];
__vue_render__$L._withStripped = true;

  /* style */
  const __vue_inject_styles__$L = undefined;
  /* scoped */
  const __vue_scope_id__$L = undefined;
  /* module identifier */
  const __vue_module_identifier__$L = undefined;
  /* functional template */
  const __vue_is_functional_template__$L = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$L = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$L, staticRenderFns: __vue_staticRenderFns__$L },
    __vue_inject_styles__$L,
    __vue_script__$L,
    __vue_scope_id__$L,
    __vue_is_functional_template__$L,
    __vue_module_identifier__$L,
    false,
    undefined,
    undefined,
    undefined
  );

var script$K = defineComponent({
    components: { DsPlusBadge: __vue_component__$L },
    name: "DsActionCard",
    props: {
        label: {
            type: String,
            required: true,
        },
        imageAlt: {
            type: String
        },
        imageUrl: {
            type: String
        },
        isPlus: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['onClick'],
    setup(props, { emit }) {
        const onClick = (e) => {
            emit('onClick', e);
        };
        return {
            onClick
        };
    },
});

/* script */
const __vue_script__$K = script$K;

/* template */
var __vue_render__$K = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-action-card",
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _vm.imageUrl
        ? _c("div", { staticClass: "ds-action-card__image" }, [
            _c("img", {
              attrs: {
                alt: _vm.imageAlt,
                height: "96",
                width: "64",
                src: _vm.imageUrl,
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ds-action-card__body" }, [
        _vm.isPlus
          ? _c(
              "div",
              { staticClass: "ds-action-card__badge" },
              [_c("ds-plus-badge", { attrs: { mobileSmall: "" } })],
              1
            )
          : _vm._e(),
        _vm._v(_vm._s(_vm.label)),
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "ds-action-card__icon chefkoch-icons" }, [
        _vm._v(""),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$K = [];
__vue_render__$K._withStripped = true;

  /* style */
  const __vue_inject_styles__$K = undefined;
  /* scoped */
  const __vue_scope_id__$K = undefined;
  /* module identifier */
  const __vue_module_identifier__$K = undefined;
  /* functional template */
  const __vue_is_functional_template__$K = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$K = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$K, staticRenderFns: __vue_staticRenderFns__$K },
    __vue_inject_styles__$K,
    __vue_script__$K,
    __vue_scope_id__$K,
    __vue_is_functional_template__$K,
    __vue_module_identifier__$K,
    false,
    undefined,
    undefined,
    undefined
  );

var script$J = defineComponent({
    name: "DsAuthor",
    props: {
        avatarUrl: {
            type: String,
            required: false,
        },
        isVerified: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            required: true
        },
    },
    setup(props) {
        const avatarAltText = computed(() => {
            return `Bild von ${props.name}`;
        });
        return {
            avatarAltText,
        };
    },
});

/* script */
const __vue_script__$J = script$J;

/* template */
var __vue_render__$J = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "ds-author ds-text-caption" }, [
    _vm.avatarUrl
      ? _c("img", {
          staticClass: "ds-author__avatar",
          attrs: {
            width: "32",
            height: "32",
            alt: _vm.avatarAltText,
            src: _vm.avatarUrl,
          },
        })
      : _vm._e(),
    _vm._v("von "),
    _c("strong", { staticClass: "ds-author__name" }, [
      _vm._v(_vm._s(_vm.name)),
    ]),
    _vm._v(" "),
    _vm.isVerified
      ? _c("i", { staticClass: "ds-author__verified-icon chefkoch-icons" }, [
          _vm._v(""),
        ])
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$J = [];
__vue_render__$J._withStripped = true;

  /* style */
  const __vue_inject_styles__$J = undefined;
  /* scoped */
  const __vue_scope_id__$J = undefined;
  /* module identifier */
  const __vue_module_identifier__$J = undefined;
  /* functional template */
  const __vue_is_functional_template__$J = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$J = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$J, staticRenderFns: __vue_staticRenderFns__$J },
    __vue_inject_styles__$J,
    __vue_script__$J,
    __vue_scope_id__$J,
    __vue_is_functional_template__$J,
    __vue_module_identifier__$J,
    false,
    undefined,
    undefined,
    undefined
  );

var script$I = defineComponent({
    name: "DsLoader",
});

/* script */
const __vue_script__$I = script$I;

/* template */
var __vue_render__$I = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass:
        "ds-loader ds-animate ds-animate--rotate ds-animate--infinite",
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "20",
            height: "20",
            viewBox: "0 0 20px 20px",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("circle", {
            staticClass: "ds-loader__circle",
            attrs: { cx: "50%", cy: "50%", r: "8" },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$I = [];
__vue_render__$I._withStripped = true;

  /* style */
  const __vue_inject_styles__$I = undefined;
  /* scoped */
  const __vue_scope_id__$I = undefined;
  /* module identifier */
  const __vue_module_identifier__$I = undefined;
  /* functional template */
  const __vue_is_functional_template__$I = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$I = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
    __vue_inject_styles__$I,
    __vue_script__$I,
    __vue_scope_id__$I,
    __vue_is_functional_template__$I,
    __vue_module_identifier__$I,
    false,
    undefined,
    undefined,
    undefined
  );

var script$H = defineComponent({
    name: "DsButton",
    components: { DsLoader: __vue_component__$I },
    props: {
        disabled: Boolean,
        label: {
            type: String
        },
        icon: {
            type: String
        },
        iconPosition: {
            type: String,
            enum: ['leading', 'trailing']
        },
        href: {
            type: String,
        },
        srOnly: {
            type: String,
        },
        flat: {
            type: Boolean,
        },
        active: {
            type: Boolean,
        },
        loading: {
            type: Boolean,
        },
        mode: {
            type: String,
            enum: [
                'primary',
                'secondary',
                'tertiary',
                'danger',
                'conversion',
                'monochrome',
                'tertiary-danger',
                'control',
                'action-menu'
            ],
            default: 'primary'
        }
    },
    setup(props) {
        const classes = computed(() => `ds-btn--${props.mode}${props.label ? '' : ' ds-btn--round'}${props.flat ? ' ds-btn--flat' : ''}${props.active ? ' ds-btn--active' : ''}${!props.icon && props.loading ? ' ds-btn--loading' : ''}`);
        const isDisabled = computed(() => props.disabled || props.loading);
        const buttonTag = computed(() => {
            if (props.href) {
                return 'a';
            }
            return 'button';
        });
        return {
            classes,
            isDisabled,
            buttonTag
        };
    },
    methods: {
        onClick(e) {
            this.$emit('onClick', e);
        },
    },
});

/* script */
const __vue_script__$H = script$H;

/* template */
var __vue_render__$H = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.buttonTag,
    {
      tag: "component",
      staticClass: "ds-btn",
      class: _vm.classes,
      attrs: {
        href: _vm.href ? _vm.href : null,
        disabled: _vm.isDisabled ? true : null,
      },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _vm.srOnly
        ? _c("span", { staticClass: "ds-sr-only" }, [
            _vm._v(_vm._s(_vm.srOnly)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.icon && _vm.label && _vm.iconPosition === "leading"
        ? _c(
            "i",
            {
              staticClass: "ds-btn__icon ds-btn__icon--leading",
              class: { "chefkoch-icons": !_vm.loading },
            },
            [_vm.loading ? [_c("ds-loader")] : [_vm._v(_vm._s(_vm.icon))]],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.icon && !_vm.label
        ? _c(
            "i",
            {
              staticClass: "ds-btn__icon",
              class: { "chefkoch-icons": !_vm.loading },
            },
            [_vm.loading ? [_c("ds-loader")] : [_vm._v(_vm._s(_vm.icon))]],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.label
        ? _c("span", { staticClass: "ds-btn__label" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.icon && _vm.label && _vm.loading
        ? _c(
            "i",
            { staticClass: "ds-btn__icon ds-btn__icon--loading" },
            [_c("ds-loader")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.icon && _vm.label && _vm.iconPosition === "trailing"
        ? _c(
            "i",
            {
              staticClass: "chefkoch-icons ds-btn__icon ds-btn__icon--trailing",
            },
            [_vm._v(_vm._s(_vm.icon))]
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$H = [];
__vue_render__$H._withStripped = true;

  /* style */
  const __vue_inject_styles__$H = undefined;
  /* scoped */
  const __vue_scope_id__$H = undefined;
  /* module identifier */
  const __vue_module_identifier__$H = undefined;
  /* functional template */
  const __vue_is_functional_template__$H = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$H = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
    __vue_inject_styles__$H,
    __vue_script__$H,
    __vue_scope_id__$H,
    __vue_is_functional_template__$H,
    __vue_module_identifier__$H,
    false,
    undefined,
    undefined,
    undefined
  );

var script$G = defineComponent({
    name: "DsButtonBox",
    props: {
        stackedMobile: Boolean,
        spaceBetween: Boolean,
    },
    setup(props, context) {
        const hasThirdButton = computed(() => !!context.slots.third);
        return {
            hasThirdButton,
        };
    },
});

/* script */
const __vue_script__$G = script$G;

/* template */
var __vue_render__$G = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-btn-box",
      class: [
        { "ds-btn-box--stack-to-xs": _vm.stackedMobile },
        { "ds-btn-box--space-between": _vm.spaceBetween },
      ],
    },
    [
      _vm.$slots.first
        ? _c(
            "div",
            { staticClass: "ds-btn-box__item ds-btn-box__item--first" },
            [_vm._t("first")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ds-btn-box__item",
          class: {
            "ds-btn-box__item--first": !_vm.$slots.first,
            "ds-btn-box__item--last": !_vm.$slots.third,
          },
        },
        [_vm._t("second")],
        2
      ),
      _vm._v(" "),
      _vm.$slots.third
        ? [
            _c(
              "div",
              {
                staticClass:
                  "ds-btn-box__item ds-btn-box__item--last ds-btn-box__item--line-break",
              },
              [_vm._t("third")],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$G = [];
__vue_render__$G._withStripped = true;

  /* style */
  const __vue_inject_styles__$G = undefined;
  /* scoped */
  const __vue_scope_id__$G = undefined;
  /* module identifier */
  const __vue_module_identifier__$G = undefined;
  /* functional template */
  const __vue_is_functional_template__$G = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$G = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
    __vue_inject_styles__$G,
    __vue_script__$G,
    __vue_scope_id__$G,
    __vue_is_functional_template__$G,
    __vue_module_identifier__$G,
    false,
    undefined,
    undefined,
    undefined
  );

var script$F = defineComponent({
    name: "DsButton",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            enum: [
                'default',
                'small',
            ],
            default: 'default'
        }
    },
    emits: ['onClick'],
    setup(props, { emit }) {
        const onClick = (e) => {
            emit('onClick', e);
        };
        return {
            onClick
        };
    },
});

/* script */
const __vue_script__$F = script$F;

/* template */
var __vue_render__$F = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass: "ds-btn ds-btn--close",
      class: { "ds-btn--size-s": _vm.size === "small" },
      attrs: { disabled: _vm.disabled },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _c("span", { staticClass: "ds-sr-only" }, [_vm._v("Schließen")]),
      _vm._v(" "),
      _c("i", { staticClass: "chefkoch-icons ds-btn__icon" }, [_vm._v("")]),
    ]
  )
};
var __vue_staticRenderFns__$F = [];
__vue_render__$F._withStripped = true;

  /* style */
  const __vue_inject_styles__$F = undefined;
  /* scoped */
  const __vue_scope_id__$F = undefined;
  /* module identifier */
  const __vue_module_identifier__$F = undefined;
  /* functional template */
  const __vue_is_functional_template__$F = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$F = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
    __vue_inject_styles__$F,
    __vue_script__$F,
    __vue_scope_id__$F,
    __vue_is_functional_template__$F,
    __vue_module_identifier__$F,
    false,
    undefined,
    undefined,
    undefined
  );

var script$E = defineComponent({
    name: "DsCoachMark",
    components: {
        DsCloseButton: __vue_component__$F,
    },
    props: {
        fluid: {
            type: Boolean,
            default: false,
        },
        plus: {
            type: Boolean,
            default: false,
        },
        position: {
            type: String,
            enum: [
                'tl',
                'tc',
                'tr',
                'bl',
                'bc',
                'br',
            ],
            default: 'tl'
        },
        text: {
            type: String,
            required: true,
        },
    },
    emits: ['onClose'],
    setup(props, { emit }) {
        const classes = computed(() => `ds-coach-mark--${props.position}${props.fluid ? ' ds-coach-mark--fluid' : ''}${props.plus ? ' ds-coach-mark--plus' : ''}`);
        const onClose = (e) => {
            e.preventDefault();
            emit('onClose');
        };
        return {
            classes,
            onClose
        };
    },
});

/* script */
const __vue_script__$E = script$E;

/* template */
var __vue_render__$E = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-coach-mark ds-coach-mark--closable",
      class: _vm.classes,
    },
    [
      _c("div", { staticClass: "ds-coach-mark__inner" }, [
        _c("div", { staticClass: "ds-coach-mark__text" }, [
          _vm._v(_vm._s(_vm.text)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ds-coach-mark__close" },
          [
            _c("DsCloseButton", {
              attrs: { size: "small" },
              on: {
                onClick: function ($event) {
                  return _vm.onClose($event)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$E = [];
__vue_render__$E._withStripped = true;

  /* style */
  const __vue_inject_styles__$E = undefined;
  /* scoped */
  const __vue_scope_id__$E = undefined;
  /* module identifier */
  const __vue_module_identifier__$E = undefined;
  /* functional template */
  const __vue_is_functional_template__$E = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$E = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
    __vue_inject_styles__$E,
    __vue_script__$E,
    __vue_scope_id__$E,
    __vue_is_functional_template__$E,
    __vue_module_identifier__$E,
    false,
    undefined,
    undefined,
    undefined
  );

const useComputedId = (props) => {
    const computedId = computed(() => {
        return props.id ? props.id : uuid();
    });
    return {
        computedId
    };
};

var script$D = defineComponent({
    name: "DsCheckbox",
    props: {
        checked: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        },
        hasError: {
            type: Boolean
        },
        id: {
            type: String
        },
        label: {
            type: String
        },
        name: {
            type: String
        },
        value: {
            type: [Number, String]
        }
    },
    emits: ['onChange'],
    setup(props, { emit }) {
        const { computedId } = useComputedId(props);
        const onChange = (e) => {
            emit('onChange', e.target.value, e.target.checked);
        };
        return {
            computedId,
            onChange
        };
    },
});

/* script */
const __vue_script__$D = script$D;

/* template */
var __vue_render__$D = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "ds-choice", class: { "ds-choice--error": _vm.hasError } },
    [
      _c("input", {
        staticClass: "ds-choice__input",
        attrs: {
          type: "checkbox",
          disabled: _vm.disabled,
          id: _vm.computedId,
          name: _vm.name,
        },
        domProps: { checked: _vm.checked, value: _vm.value },
        on: { change: _vm.onChange },
      }),
      _vm._v(" "),
      _c(
        "i",
        {
          staticClass: "chefkoch-icons ds-choice__icon ds-choice__icon--active",
        },
        [_vm._v("\n    \n  ")]
      ),
      _vm._v(" "),
      _c(
        "i",
        {
          staticClass:
            "chefkoch-icons ds-choice__icon ds-choice__icon--inactive",
        },
        [_vm._v("\n    \n  ")]
      ),
      _vm._v(" "),
      _vm.label
        ? _c(
            "label",
            { staticClass: "ds-choice__label", attrs: { for: _vm.computedId } },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$D = [];
__vue_render__$D._withStripped = true;

  /* style */
  const __vue_inject_styles__$D = undefined;
  /* scoped */
  const __vue_scope_id__$D = undefined;
  /* module identifier */
  const __vue_module_identifier__$D = undefined;
  /* functional template */
  const __vue_is_functional_template__$D = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$D = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
    __vue_inject_styles__$D,
    __vue_script__$D,
    __vue_scope_id__$D,
    __vue_is_functional_template__$D,
    __vue_module_identifier__$D,
    false,
    undefined,
    undefined,
    undefined
  );

var script$C = defineComponent({
    name: "DsFormItem",
    props: {
        errorMsg: {
            type: String,
        },
        hint: {
            type: String,
        },
        id: {
            type: String,
        },
        isChoice: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
        },
        labelIcon: {
            type: String,
        },
        maxLength: {
            type: Number,
            required: false
        },
        value: {
            type: [String, Number],
            required: false
        }
    },
    setup(props) {
        const { computedId } = useComputedId(props);
        const showFooter = computed(() => {
            return props.errorMsg || props.maxLength;
        });
        const valueLength = computed(() => {
            return props.value ? props.value.toString().length : 0;
        });
        return {
            computedId,
            showFooter,
            valueLength,
        };
    }
});

/* script */
const __vue_script__$C = script$C;

/* template */
var __vue_render__$C = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "ds-form-item" }, [
    _vm.label
      ? _c(
          "label",
          {
            staticClass: "ds-form-item__label",
            attrs: { for: _vm.computedId },
          },
          [
            _vm.labelIcon
              ? _c(
                  "i",
                  { staticClass: "ds-form-item__label-icon chefkoch-icons" },
                  [_vm._v(_vm._s(_vm.labelIcon))]
                )
              : _vm._e(),
            _vm._v(_vm._s(_vm.label)),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hint
      ? _c("div", { staticClass: "ds-form-item__text" }, [
          _vm._v(_vm._s(_vm.hint)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ds-form-item__control",
        class: {
          "ds-form-item__control--mb-0": !_vm.label && !_vm.hint,
          "ds-form-item__control--choice": _vm.isChoice,
        },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.showFooter
      ? _c(
          "div",
          {
            staticClass: "ds-form-item__footer",
            class: { "ds-form-item__footer--choice": _vm.isChoice },
          },
          [
            _vm.errorMsg
              ? _c(
                  "div",
                  {
                    staticClass: "ds-form-item__text ds-form-item__text--error",
                  },
                  [_vm._v(_vm._s(_vm.errorMsg))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.maxLength
              ? _c(
                  "div",
                  {
                    staticClass:
                      "ds-form-item__text ds-form-item__text--bottom-right",
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.valueLength) + "/" + _vm._s(_vm.maxLength)
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$C = [];
__vue_render__$C._withStripped = true;

  /* style */
  const __vue_inject_styles__$C = undefined;
  /* scoped */
  const __vue_scope_id__$C = undefined;
  /* module identifier */
  const __vue_module_identifier__$C = undefined;
  /* functional template */
  const __vue_is_functional_template__$C = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$C = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
    __vue_inject_styles__$C,
    __vue_script__$C,
    __vue_scope_id__$C,
    __vue_is_functional_template__$C,
    __vue_module_identifier__$C,
    false,
    undefined,
    undefined,
    undefined
  );

var script$B = defineComponent({
    name: "DsChoices",
    components: {
        DsFormItem: __vue_component__$C
    },
    props: {
        choices: {
            type: Array,
        },
        errorMsg: {
            type: String,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        hint: {
            type: String,
        },
        id: {
            type: String,
        },
        label: {
            type: String,
        },
        labelIcon: {
            type: String,
        },
        name: {
            type: String,
        },
    },
    setup(props) {
        const { computedId } = useComputedId(props);
        return {
            computedId,
        };
    }
});

/* script */
const __vue_script__$B = script$B;

/* template */
var __vue_render__$B = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "DsFormItem",
    {
      attrs: {
        errorMsg: _vm.hasError && _vm.errorMsg ? _vm.errorMsg : null,
        hint: _vm.hint,
        id: _vm.computedId,
        label: _vm.label,
        labelIcon: _vm.labelIcon,
        isChoice: "",
      },
    },
    [
      _c(
        "ul",
        { staticClass: "ds-choices" },
        [_vm.$slots.default ? [_vm._t("default")] : _vm._e()],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$B = [];
__vue_render__$B._withStripped = true;

  /* style */
  const __vue_inject_styles__$B = undefined;
  /* scoped */
  const __vue_scope_id__$B = undefined;
  /* module identifier */
  const __vue_module_identifier__$B = undefined;
  /* functional template */
  const __vue_is_functional_template__$B = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$B = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
    __vue_inject_styles__$B,
    __vue_script__$B,
    __vue_scope_id__$B,
    __vue_is_functional_template__$B,
    __vue_module_identifier__$B,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$A = defineComponent({
  name: "DsChoicesItem"
});

/* script */
const __vue_script__$A = script$A;

/* template */
var __vue_render__$A = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("li", { staticClass: "ds-choices__item" }, [_vm._t("default")], 2)
};
var __vue_staticRenderFns__$A = [];
__vue_render__$A._withStripped = true;

  /* style */
  const __vue_inject_styles__$A = undefined;
  /* scoped */
  const __vue_scope_id__$A = undefined;
  /* module identifier */
  const __vue_module_identifier__$A = undefined;
  /* functional template */
  const __vue_is_functional_template__$A = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$A = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
    __vue_inject_styles__$A,
    __vue_script__$A,
    __vue_scope_id__$A,
    __vue_is_functional_template__$A,
    __vue_module_identifier__$A,
    false,
    undefined,
    undefined,
    undefined
  );

const useClickOutside = (target, callback) => {
    const eventListener = (event) => {
        const insideTarget = event.composedPath().includes(unref(target));
        if (!insideTarget) {
            callback();
        }
    };
    if (hasWindow()) {
        let stop = noop;
        const options = { passive: true, capture: true };
        const stopWatching = watch(() => unref(target), () => {
            stop();
            window.addEventListener('click', eventListener, options);
            stop = () => {
                window.removeEventListener('click', eventListener, options);
                stop = noop;
            };
        });
        const stopAll = () => {
            stopWatching();
            stop();
        };
        onScopeDispose(() => {
            stopAll();
        });
        return stopAll;
    }
};

const useCollectionInfo = (props) => {
    const followerUnit = computed(() => {
        return 'Follower';
    });
    const linkTag = computed(() => {
        if (props.siteUrl) {
            return 'a';
        }
        return 'div';
    });
    const linkTitleFormatted = computed(() => {
        return props.linkTitle || `Zur Sammlung ${props.title}`;
    });
    const niceDate = computed(() => {
        try {
            return formatNiceDate(props.dateString);
        }
        catch (e) {
            return "";
        }
    });
    const recipeString = computed(() => {
        if (props.alreadyInCollection) {
            return 'Bereits in dieser Sammlung';
        }
        return `${props.recipeCount} Rezept${props.recipeCount !== 1 ? 'e' : ''}`;
    });
    return {
        followerUnit,
        linkTag,
        linkTitleFormatted,
        niceDate,
        recipeString,
    };
};

const useEscapeKey = (callback) => {
    const escKeyAttached = ref(false);
    const onEscape = (e) => {
        if (e.key === 'Escape') {
            callback();
        }
    };
    const attachEscapeKeyHandler = () => {
        if (hasDocument()) {
            document.addEventListener('keydown', onEscape);
            escKeyAttached.value = true;
        }
    };
    const removeEscapeKeyHandler = () => {
        if (escKeyAttached.value) {
            if (hasDocument()) {
                document.removeEventListener('keydown', onEscape);
                escKeyAttached.value = false;
            }
        }
    };
    return {
        attachEscapeKeyHandler,
        removeEscapeKeyHandler
    };
};

const useRecipeInfo = (props) => {
    const linkTag = computed(() => {
        if (props.siteUrl) {
            return 'a';
        }
        return 'div';
    });
    const linkTitleFormatted = computed(() => {
        return props.linkTitle || `Zum Rezept ${props.title}`;
    });
    const privateBadgeClass = computed(() => {
        if (props.isPlus && props.isPrivate) {
            return `ds-card-badge--plus`;
        }
        return `ds-card-badge--inverted`;
    });
    const showRating = computed(() => {
        return !props.isPlus && !isNaN(props.rating) && !isNaN(props.numVotes);
    });
    return {
        linkTag,
        linkTitleFormatted,
        privateBadgeClass,
        showRating,
    };
};

const imageWidths = [160, 240, 320, 480, 640, 960];
const maxWidthLandscape = 960;
const maxWidthPortrait = 640;
const breakpoints = {
    cols: {
        breakpoint: 0,
        container: 479,
        gap: 16,
        fullResponsive: true,
    },
    xs: {
        breakpoint: 480,
        container: 599,
        gap: 16,
        fullResponsive: true,
    },
    s: {
        breakpoint: 600,
        container: 568,
        gap: 16,
        fullResponsive: false,
    },
    sm: {
        breakpoint: 768,
        container: 672,
        gap: 16,
        fullResponsive: false,
    },
    m: {
        breakpoint: 1196,
        container: 996,
        gap: 24,
        fullResponsive: false,
    },
};
function imageIsProcessable(src) {
    if (process.env.NODE_ENV === 'development' && src.startsWith('/') || src.endsWith('.svg')) {
        return false;
    }
    let imageUrl = src;
    if (imageUrl.startsWith('/')) {
        imageUrl = 'https://www.chefkoch.de' + imageUrl;
    }
    const url = new URL(imageUrl);
    const isCkHosted = url.hostname.match(/\.chefkoch(-cdn)?\.de$/);
    if (!isCkHosted) {
        // eslint-disable-next-line no-console
        console.info(`ImageService: Not processing image via ImageProcessor: ${imageUrl}`);
        return false;
    }
    return true;
}
function getValidImageSizes(aspectRatio) {
    const validImageSizes = [];
    let maxWidth = maxWidthLandscape;
    if (getFractureForAspectRatio(aspectRatio) < 1) {
        maxWidth = maxWidthPortrait;
    }
    imageWidths.forEach((width) => {
        if (width <= maxWidth) {
            validImageSizes.push(width);
        }
    });
    return validImageSizes;
}
function getImageUrl(src, aspectRatio, imageWidth) {
    if (process.env.NODE_ENV === 'development' && src.startsWith('/')) {
        return src;
    }
    let imageUrl = src;
    if (imageIsProcessable(imageUrl) && !imageUrl.includes('<format>')) {
        if (imageUrl.startsWith('/')) {
            imageUrl = 'https://www.chefkoch.de' + imageUrl;
        }
        const url = new URL(imageUrl);
        imageUrl = `https://${url.host}/images/<format>${url.pathname}${url.search}`;
    }
    const imageHeight = imageWidth / getFractureForAspectRatio(aspectRatio);
    const imageFormat = `crop-${imageWidth}x${imageHeight}`;
    return imageUrl.replace('<format>', imageFormat).replace('<aspectRatio>', aspectRatio);
}
function calculateColumnWidth(containerWidth, columnSize, gapWidth) {
    const gapCount = Math.ceil(12 / columnSize) + 1;
    return Math.ceil((containerWidth - gapWidth * gapCount) / (12 / columnSize));
}
function getFractureForAspectRatio(aspectRatio) {
    return aspectRatio.split('x').map(e => parseInt(e)).reduce((a, b) => a / b);
}
// composable
function useResponsiveImage(props) {
    const imgSrc = computed(() => {
        return getImageUrl(props.imageTemplate, props.aspectRatio, 640);
    });
    /**
     * Generates the string for the srcset image attribute
     *  e.g.: "/path/160x200.jpg 160w, /path/240x300.jpg 240w, /path/320x400.jpg 320w"
     *
     */
    const imgSrcSet = computed(() => {
        if (!imageIsProcessable(props.imageTemplate)) {
            return '';
        }
        const sources = [];
        const imageSizes = getValidImageSizes(props.aspectRatio);
        const addImageSource = (imageWidth) => {
            const source = getImageUrl(props.imageTemplate, props.aspectRatio, imageWidth);
            if (!sources.find((element) => element.width === imageWidth)) {
                sources.push({ url: source, width: imageWidth });
            }
        };
        Object.entries(breakpoints).forEach(([breakpoint, widths]) => {
            let columnSize = props[breakpoint] || 12;
            const colWidth = calculateColumnWidth(widths.container, columnSize, widths.gap);
            let imageWidth = 0;
            imageSizes.forEach((width) => {
                if (width >= colWidth && imageWidth === 0) {
                    imageWidth = width;
                }
            });
            if (imageWidth > 0) {
                addImageSource(imageWidth);
            }
            // provide high density images
            let imageWidthHd = 0;
            for (const density of [2, 1.5]) {
                if (imageSizes.includes(imageWidth * density) && imageWidthHd === 0) {
                    imageWidthHd = imageWidth * density;
                }
            }
            if (imageWidthHd > 0) {
                addImageSource(imageWidthHd);
            }
        });
        return sources
            .sort((img1, img2) => img1.width - img2.width)
            .map((source) => `${source.url} ${source.width}w`)
            .join(', ');
    });
    /**
     * Generates the string for the sizes image attribute
     *  e.g.: "(min-width: 1196px) 219px, (min-width: 600px) 203px, calc(0.5 * (100vw - 48px))"
     *
     */
    const imgSizes = computed(() => {
        if (!imageIsProcessable(props.imageTemplate)) {
            return '';
        }
        const sizes = new Set();
        let columnSize = 12;
        Object.entries(breakpoints).forEach(([breakpoint, widths]) => {
            if (typeof props[breakpoint] !== 'undefined') {
                columnSize = props[breakpoint];
            }
            let width;
            if (widths.fullResponsive) {
                const gap = widths.gap * (Math.ceil(12 / columnSize) + 1); // sum of all gaps between the cards
                const column = columnSize / 12;
                width = `calc(${column} * (100vw - ${gap}px))`;
            }
            else {
                const colWidth = calculateColumnWidth(widths.container, columnSize, widths.gap);
                width = `${colWidth}px`;
            }
            sizes.add({
                breakpoint: widths.breakpoint,
                width,
            });
        });
        return [...sizes]
            .sort((size1, size2) => 
        // Sort descending by breakpoint
        size2.breakpoint - size1.breakpoint)
            .filter(
        // Filter out all definitions that are equal to the next step. In other words: Try to not list
        // duplicate definitions that would be valid for the next breakpoint.
        (size, index, arr) => size.width !== (arr[index + 1] || {}).width)
            .map((size, index, arr) => 
        // Prepend min-widths, except for the smallest (=last; default) breakpoint
        index === arr.length - 1
            ? size.width
            : `(min-width: ${size.breakpoint}px) ${size.width}`)
            .join(', ');
    });
    return {
        imgSrc,
        imgSrcSet,
        imgSizes,
    };
}

const useScroll = (target) => {
    const scrollState = reactive({
        left: true,
        right: false,
    });
    const x = ref(0);
    const y = ref(0);
    const eventListener = (event) => {
        const target = event.target;
        const scrollLeft = target.scrollLeft;
        x.value = scrollLeft;
        y.value = target.scrollTop;
        scrollState.left = scrollLeft <= 0;
        scrollState.right = scrollLeft + target.clientWidth >= target.scrollWidth - 1;
    };
    let stop = noop;
    const options = { passive: true, capture: false };
    const stopWatching = watch(() => unref(target), (el) => {
        stop();
        el.addEventListener('scroll', eventListener, options);
        stop = () => {
            el.removeEventListener('scroll', eventListener, options);
            stop = noop;
        };
    });
    const stopAll = () => {
        stopWatching();
        stop();
    };
    onScopeDispose(() => {
        stopAll();
    });
    return {
        scrollState,
        x,
        y,
    };
};

const snackbars = ref([]);
const useSnackbar = () => {
    const addSnackbar = (options) => {
        const id = (new Date()).getTime().toString();
        snackbars.value.push({ id, ...options });
        return id;
    };
    const removeSnackbar = (id) => {
        const index = snackbars.value.findIndex((el) => {
            return el.id === id;
        });
        if (index >= 0) {
            snackbars.value.splice(index, 1);
        }
    };
    return {
        addSnackbar,
        removeSnackbar,
        snackbars: readonly(snackbars)
    };
};

const useWindowResize = () => {
    const width = ref(Infinity);
    const height = ref(Infinity);
    const update = () => {
        width.value = window.innerWidth;
        height.value = window.innerWidth;
    };
    if (hasWindow()) {
        onMounted(() => {
            update();
            window.addEventListener('resize', update);
        });
        onUnmounted(() => {
            window.removeEventListener('resize', update);
        });
    }
    return {
        width,
        height
    };
};

var script$z = defineComponent({
    props: {
        imageTemplate: {
            type: String,
            required: true,
        },
        aspectRatio: {
            type: String,
            enum: [
                '16x9',
                '4x5',
                '4x3',
                '3x2'
            ],
            required: true,
        },
        cols: {
            type: Number,
            default: 12,
            required: false
        },
        xs: {
            type: Number,
            required: false,
        },
        s: {
            type: Number,
            required: false,
        },
        sm: {
            type: Number,
            required: false,
        },
        m: {
            type: Number,
            required: false,
        },
    },
    setup(props) {
        const { imgSrc, imgSrcSet, imgSizes } = useResponsiveImage(props);
        return {
            imgSrc,
            imgSrcSet,
            imgSizes,
        };
    }
});

/* script */
const __vue_script__$z = script$z;

/* template */
var __vue_render__$z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("img", {
    attrs: {
      loading: "lazy",
      src: _vm.imgSrc,
      srcset: _vm.imgSrcSet ? _vm.imgSrcSet : null,
      sizes: _vm.imgSizes ? _vm.imgSizes : null,
    },
  })
};
var __vue_staticRenderFns__$z = [];
__vue_render__$z._withStripped = true;

  /* style */
  const __vue_inject_styles__$z = undefined;
  /* scoped */
  const __vue_scope_id__$z = undefined;
  /* module identifier */
  const __vue_module_identifier__$z = undefined;
  /* functional template */
  const __vue_is_functional_template__$z = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$z = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
    __vue_inject_styles__$z,
    __vue_script__$z,
    __vue_scope_id__$z,
    __vue_is_functional_template__$z,
    __vue_module_identifier__$z,
    false,
    undefined,
    undefined,
    undefined
  );

var script$y = defineComponent({
    name: "DsCollectionCard",
    components: {
        DsAuthor: __vue_component__$J,
        DsPlusBadge: __vue_component__$L,
        DsResponsiveImage: __vue_component__$z,
    },
    props: {
        authorAvatarUrl: {
            type: String,
            required: false,
        },
        authorIsVerified: {
            type: Boolean,
            required: false,
        },
        authorName: {
            type: String,
            required: false,
        },
        followerCount: {
            type: Number,
            required: false
        },
        dateString: {
            type: String,
            required: true
        },
        gridCols: {
            type: Number,
            default: 12,
        },
        gridM: {
            type: Number,
            default: 4,
        },
        gridS: {
            type: Number,
            default: 6,
        },
        hasImage: {
            type: Boolean,
            default: true,
        },
        imageTemplate: {
            type: String,
        },
        isDeactivated: {
            type: Boolean,
            required: false,
            default: false,
        },
        isInverted: {
            type: Boolean,
            required: false,
            default: false,
        },
        isPlus: {
            type: Boolean,
            required: false,
            default: false
        },
        isPrivate: {
            type: Boolean,
            required: false,
            default: false
        },
        linkTitle: {
            type: String,
            required: false
        },
        recipeCount: {
            type: Number,
            default: 0,
            required: true,
        },
        siteUrl: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: true
        }
    },
    emits: ['onClick'],
    setup(props, { emit }) {
        const { followerUnit, linkTag, linkTitleFormatted, niceDate, recipeString } = useCollectionInfo(props);
        const linkClasses = computed(() => {
            return `ds-collection-card__link${props.siteUrl ? ' ds-teaser-link' : ''}`;
        });
        const onClick = (event) => {
            emit('onClick', event);
        };
        return {
            followerUnit,
            linkClasses,
            linkTag,
            linkTitleFormatted,
            niceDate,
            onClick,
            recipeString,
        };
    },
});

/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-collection-card",
      class: {
        "ds-collection-card--deactivated": _vm.isDeactivated,
        "ds-collection-card--inverted": _vm.isInverted,
      },
    },
    [
      _c(
        _vm.linkTag,
        {
          tag: "component",
          class: _vm.linkClasses,
          attrs: {
            href: !!_vm.siteUrl ? _vm.siteUrl : null,
            title: !!_vm.siteUrl ? _vm.linkTitleFormatted : null,
          },
          on: {
            click: function ($event) {
              return _vm.onClick($event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "ds-collection-card__image-wrap ds-teaser-link__image-wrap",
            },
            [
              !_vm.hasImage || !_vm.imageTemplate
                ? _c("img", {
                    class: "ds-collection-card__image ds-teaser-link__image",
                    attrs: {
                      alt: _vm.title,
                      loading: "lazy",
                      src: "https://img.chefkoch-cdn.de/assets/v2/img/placeholders/16x9/collection.svg",
                    },
                  })
                : _c("ds-responsive-image", {
                    class: "ds-collection-card__image ds-teaser-link__image",
                    attrs: {
                      alt: _vm.title,
                      aspectRatio: "16x9",
                      imageTemplate: _vm.imageTemplate,
                      cols: _vm.gridCols,
                      s: _vm.gridS,
                      m: _vm.gridM,
                    },
                  }),
              _vm._v(" "),
              _c("div", { staticClass: "ds-collection-card__body" }, [
                _c(
                  "h3",
                  {
                    staticClass:
                      "ds-collection-card__headline ds-text-sans ds-trunc ds-trunc-1",
                  },
                  [_vm._v(_vm._s(_vm.title))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "ds-collection-card__recipe-count ds-text-caption",
                  },
                  [_vm._v(_vm._s(_vm.recipeString))]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ds-collection-card__infos" }, [
            _c("div", { staticClass: "ds-collection-card__info-top" }, [
              _c(
                "span",
                { staticClass: "ds-collection-card__date ds-text-caption" },
                [_vm._v(_vm._s(_vm.niceDate))]
              ),
              _vm._v(" "),
              !_vm.isPrivate &&
              !_vm.isDeactivated &&
              _vm.followerCount !== undefined
                ? _c(
                    "span",
                    {
                      staticClass:
                        "ds-collection-card__info-item ds-text-caption",
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass:
                            "ds-collection-card__info-icon chefkoch-icons",
                        },
                        [_vm._v("")]
                      ),
                      _c("strong", { staticClass: "ds-text-semi-bold" }, [
                        _vm._v(_vm._s(_vm.followerCount)),
                      ]),
                      _vm._v(" " + _vm._s(_vm.followerUnit)),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ds-collection-card__info-bottom" },
              [
                _vm.isDeactivated
                  ? [
                      _c(
                        "span",
                        {
                          staticClass:
                            "ds-collection-card__info-item ds-text-caption",
                        },
                        [_vm._v("Sammlung wurde deaktiviert")]
                      ),
                    ]
                  : [
                      _vm.isPrivate
                        ? [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "ds-collection-card__info-item ds-text-caption",
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "ds-collection-card__info-icon chefkoch-icons",
                                  },
                                  [_vm._v("")]
                                ),
                                _c("span", [_vm._v("Private Sammlung")]),
                              ]
                            ),
                          ]
                        : [
                            _vm.authorName
                              ? [
                                  _c("ds-author", {
                                    attrs: {
                                      name: _vm.authorName,
                                      isVerified: _vm.authorIsVerified,
                                      avatarUrl: _vm.authorAvatarUrl,
                                    },
                                  }),
                                ]
                              : [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "ds-collection-card__info-item ds-text-caption",
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "ds-collection-card__info-icon chefkoch-icons",
                                        },
                                        [_vm._v("")]
                                      ),
                                      _c("span", [
                                        _vm._v("Öffentliche Sammlung"),
                                      ]),
                                    ]
                                  ),
                                ],
                          ],
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.isPlus || _vm.isDeactivated
            ? _c(
                "div",
                {
                  staticClass:
                    "ds-collection-card__action ds-collection-card__action--left",
                  class: {
                    "ds-collection-card__action--plus":
                      _vm.isPlus && !_vm.isDeactivated,
                  },
                },
                [
                  _vm.isPlus && !_vm.isDeactivated
                    ? _c("ds-plus-badge")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isDeactivated
                    ? _c(
                        "div",
                        {
                          staticClass: "ds-card-badge ds-card-badge--inverted",
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "chefkoch-icons ds-card-badge__icon",
                            },
                            [_vm._v("")]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.$slots.menu
        ? [
            _c(
              "div",
              { staticClass: "ds-collection-card__action" },
              [_vm._t("menu")],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$y = [];
__vue_render__$y._withStripped = true;

  /* style */
  const __vue_inject_styles__$y = undefined;
  /* scoped */
  const __vue_scope_id__$y = undefined;
  /* module identifier */
  const __vue_module_identifier__$y = undefined;
  /* functional template */
  const __vue_is_functional_template__$y = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$y = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
    __vue_inject_styles__$y,
    __vue_script__$y,
    __vue_scope_id__$y,
    __vue_is_functional_template__$y,
    __vue_module_identifier__$y,
    false,
    undefined,
    undefined,
    undefined
  );

var script$x = defineComponent({
    name: "DsTextToggle",
    props: {
        isTruncated: {
            type: Boolean,
            default: true,
            required: false
        },
        maxLines: {
            type: Number,
            default: 3,
            required: false
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            required: true
        }
    },
    emits: ['onClick'],
    setup(props, { emit }) {
        const truncated = ref(props.isTruncated);
        const onClick = (event) => {
            event.preventDefault();
            emit('onClick', event);
            if (!props.readonly) {
                truncated.value = !truncated.value;
            }
        };
        return {
            onClick,
            truncated
        };
    },
});

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$x = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-text-toggle",
      class: { "ds-text-toggle--readonly": _vm.readonly },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _vm.readonly
        ? [
            _c("i", { staticClass: "ds-text-toggle__icon chefkoch-icons" }, [
              _vm._v(""),
            ]),
          ]
        : [
            _vm.truncated
              ? _c(
                  "i",
                  { staticClass: "ds-text-toggle__icon chefkoch-icons" },
                  [_vm._v("")]
                )
              : _c(
                  "i",
                  { staticClass: "ds-text-toggle__icon chefkoch-icons" },
                  [_vm._v("")]
                ),
          ],
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "ds-text-toggle__text ds-text-caption",
          class:
            ((_obj = { "ds-trunc": _vm.truncated }),
            (_obj["ds-trunc-" + _vm.maxLines] = _vm.truncated),
            _obj),
        },
        [_vm._v("\n    „" + _vm._s(_vm.text) + "”\n  ")]
      ),
    ],
    2
  )
};
var __vue_staticRenderFns__$x = [];
__vue_render__$x._withStripped = true;

  /* style */
  const __vue_inject_styles__$x = undefined;
  /* scoped */
  const __vue_scope_id__$x = undefined;
  /* module identifier */
  const __vue_module_identifier__$x = undefined;
  /* functional template */
  const __vue_is_functional_template__$x = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$x = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
    __vue_inject_styles__$x,
    __vue_script__$x,
    __vue_scope_id__$x,
    __vue_is_functional_template__$x,
    __vue_module_identifier__$x,
    false,
    undefined,
    undefined,
    undefined
  );

/* sizes for m, s and mobile */
const imgWidths = [162, 126, 96];
var script$w = defineComponent({
    name: "DsCollectionListItem",
    components: {
        DsAuthor: __vue_component__$J,
        DsPlusBadge: __vue_component__$L,
        DsTextToggle: __vue_component__$x,
    },
    props: {
        alreadyInCollection: {
            type: Boolean,
            required: false,
        },
        authorIsVerified: {
            type: Boolean,
            required: false,
        },
        authorName: {
            type: String,
            required: false,
        },
        avatarUrl: {
            type: String,
            required: false,
        },
        followerCount: {
            type: Number,
            required: false
        },
        dateString: {
            type: String,
            required: true
        },
        hasImage: {
            type: Boolean,
            default: true,
        },
        imageTemplate: {
            type: String,
        },
        inOverlay: {
            type: Boolean,
            required: false,
            default: false,
        },
        isChecked: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDeactivated: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        isInverted: {
            type: Boolean,
            required: false,
            default: false,
        },
        isPlus: {
            type: Boolean,
            required: false,
            default: false
        },
        isPrivate: {
            type: Boolean,
            required: false,
            default: false
        },
        isSelectable: {
            type: Boolean,
            required: false,
            default: false
        },
        linkTitle: {
            type: String,
            required: false
        },
        note: {
            type: String,
            required: false
        },
        recipeCount: {
            type: Number,
            default: 0,
            required: true,
        },
        siteUrl: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: true
        }
    },
    emits: ['onClick'],
    setup(props, { emit }) {
        const { followerUnit, linkTag, linkTitleFormatted, niceDate, recipeString } = useCollectionInfo(props);
        const classes = computed(() => {
            return `${props.isDeactivated ? 'ds-list-view-item--deactivated' : ''}
        ${props.inOverlay ? ' ds-list-view-item--dialog' : ''}
        ${props.isInverted ? ' ds-list-view-item--inverted' : ''}
        ${props.isDisabled ? ' ds-list-view-item--disabled' : ''}
        `;
        });
        const imgSizes = computed(() => {
            return `(min-width:1196px) ${imgWidths[0]}px, (min-width: 600px) ${imgWidths[1]}px, ${imgWidths[2]}px`;
        });
        const imgSrc = computed(() => {
            if (!props.imageTemplate) {
                return '';
            }
            return getImageUrl(props.imageTemplate, '3x2', imgWidths[2]);
        });
        const imgSrcSet = computed(() => {
            if (!props.imageTemplate) {
                return '';
            }
            return imgWidths.map((width) => {
                return `${getImageUrl(props.imageTemplate, '3x2', 2 * width)} ${2 * width}w,
          ${getImageUrl(props.imageTemplate, '3x2', width)} ${width}w`;
            })
                .join(',');
        });
        const linkClasses = computed(() => {
            return `ds-list-view-item__link${props.siteUrl ? ' ds-teaser-link' : ''}`;
        });
        const onClick = (event) => {
            emit('onClick', event);
        };
        const onTextToggleClick = (event) => {
            event.stopPropagation();
        };
        return {
            classes,
            followerUnit,
            imgSizes,
            imgSrc,
            imgSrcSet,
            linkClasses,
            linkTag,
            linkTitleFormatted,
            niceDate,
            onClick,
            onTextToggleClick,
            recipeString,
        };
    }
});

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-list-view-item ds-list-view-item--collection",
      class: _vm.classes,
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _c(
        _vm.linkTag,
        {
          tag: "component",
          class: _vm.linkClasses,
          attrs: {
            href: !!_vm.siteUrl ? _vm.siteUrl : null,
            title: !!_vm.siteUrl ? _vm.linkTitleFormatted : null,
          },
        },
        [
          _c("div", { staticClass: "ds-list-view-item__media" }, [
            _c("div", { staticClass: "ds-list-view-item__image-wrap" }, [
              !_vm.hasImage || !_vm.imageTemplate
                ? _c("img", {
                    class: "ds-list-view-item__image",
                    attrs: {
                      alt: _vm.title,
                      loading: "lazy",
                      src: "https://img.chefkoch-cdn.de/assets/v2/img/placeholders/3x2/collection.svg",
                    },
                  })
                : _c("img", {
                    staticClass: "ds-list-view-item__image",
                    attrs: {
                      width: "162",
                      height: "108",
                      loading: "lazy",
                      alt: _vm.title,
                      src: _vm.imgSrc,
                      srcset: _vm.imgSrcSet,
                      sizes: _vm.imgSizes,
                    },
                  }),
              _vm._v(" "),
              _vm.isPlus || _vm.isDeactivated
                ? _c(
                    "div",
                    { staticClass: "ds-list-view-item__badge" },
                    [
                      _vm.isPlus && !_vm.isDeactivated
                        ? _c("ds-plus-badge")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDeactivated && !_vm.inOverlay
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "ds-card-badge ds-card-badge--inverted ds-card-badge--mobile-small",
                            },
                            [
                              _c(
                                "i",
                                {
                                  staticClass:
                                    "chefkoch-icons ds-card-badge__icon",
                                },
                                [_vm._v("")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ds-list-view-item__body" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "ds-list-view-item__column ds-list-view-item__column--info",
                  class: { "ds-list-view-item__column--full": _vm.inOverlay },
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "ds-list-view-item__headline ds-teaser-link__headline ds-h4 ds-trunc ds-trunc-1 ds-text-sans",
                    },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ds-list-view-item__info-top" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "ds-list-view-item__recipe-count ds-text-caption",
                      },
                      [_vm._v(_vm._s(_vm.recipeString))]
                    ),
                    _vm._v(" "),
                    !_vm.inOverlay && _vm.followerCount !== undefined
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "ds-list-view-item__info-item ds-text-caption",
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass:
                                  "ds-list-view-item__info-icon chefkoch-icons",
                              },
                              [_vm._v("")]
                            ),
                            _c("strong", { staticClass: "ds-text-semi-bold" }, [
                              _vm._v(_vm._s(_vm.followerCount)),
                            ]),
                            _vm._v(" " + _vm._s(_vm.followerUnit)),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  !_vm.inOverlay
                    ? _c(
                        "div",
                        { staticClass: "ds-list-view-item__info-bottom" },
                        [
                          _vm.isDeactivated
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "ds-list-view-item__info-item ds-text-caption",
                                  },
                                  [_vm._v("Sammlung wurde deaktiviert")]
                                ),
                              ]
                            : [
                                _vm.isPrivate
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ds-list-view-item__info-item ds-text-caption",
                                        },
                                        [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "chefkoch-icons ds-list-view-item__info-icon",
                                            },
                                            [_vm._v("")]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "ds-list-view-item__visibility-text",
                                            },
                                            [
                                              _vm._v("Privat"),
                                              _c(
                                                "span",
                                                { staticClass: "ds-from-s" },
                                                [_vm._v("e Sammlung")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _vm.authorName
                                        ? [
                                            _c("ds-author", {
                                              attrs: {
                                                name: _vm.authorName,
                                                isVerified:
                                                  _vm.authorIsVerified,
                                              },
                                            }),
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ds-list-view-item__info-item ds-text-caption",
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "chefkoch-icons ds-list-view-item__info-icon",
                                                  },
                                                  [_vm._v("")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "ds-list-view-item__visibility-text",
                                                  },
                                                  [
                                                    _vm._v("Öffentlich"),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "ds-from-s",
                                                      },
                                                      [_vm._v("e Sammlung")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                    ],
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              !_vm.inOverlay
                ? [
                    _vm.note
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ds-list-view-item__column ds-list-view-item__column--note",
                          },
                          [
                            _c("ds-text-toggle", {
                              attrs: { text: _vm.note, readonly: "" },
                              on: { onClick: _vm.onTextToggleClick },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "ds-list-view-item__column ds-list-view-item__column--date",
                      },
                      [
                        _c("span", { staticClass: "ds-text-caption" }, [
                          _vm._v(_vm._s(_vm.niceDate)),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ds-list-view-item__action" },
        [
          _vm.isSelectable
            ? [
                _vm.isChecked
                  ? _c("i", { staticClass: "chefkoch-icons" }, [_vm._v("")])
                  : _c("i", { staticClass: "chefkoch-icons" }, [_vm._v("")]),
              ]
            : [_vm._t("menu")],
        ],
        2
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$w = [];
__vue_render__$w._withStripped = true;

  /* style */
  const __vue_inject_styles__$w = undefined;
  /* scoped */
  const __vue_scope_id__$w = undefined;
  /* module identifier */
  const __vue_module_identifier__$w = undefined;
  /* functional template */
  const __vue_is_functional_template__$w = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$w = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
    __vue_inject_styles__$w,
    __vue_script__$w,
    __vue_scope_id__$w,
    __vue_is_functional_template__$w,
    __vue_module_identifier__$w,
    false,
    undefined,
    undefined,
    undefined
  );

const getTotalHeight = (alignTop, flyoutRect, triggerRect) => {
    let spaceBetween = flyoutRect.top - triggerRect.bottom;
    if (alignTop) {
        spaceBetween = triggerRect.top - flyoutRect.bottom;
    }
    return spaceBetween + triggerRect.height + flyoutRect.height;
};
var script$v = defineComponent({
    components: { DsCloseButton: __vue_component__$F },
    name: "DsContextMenu",
    props: {
        attachToBody: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
        },
        show: {
            type: Boolean,
            default: false,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        actionItems: {
            type: Array,
        },
        inScroll: {
            type: Boolean,
            default: false,
        },
        alignRight: {
            type: Boolean,
            default: false,
        },
        alignTop: {
            type: Boolean,
            default: false,
        },
        collision: {
            type: String,
            enum: ['flip', 'none'],
            default: 'none'
        },
        flyoutOffset: String,
    },
    setup(props, { emit }) {
        const contextMenuRef = ref(null);
        const contextMenuBackdropRef = ref(null);
        const contextMenuTriggerRef = ref(null);
        const contextMenuFlyoutRef = ref(null);
        const canAlignTop = ref(props.alignTop);
        const canAlignRight = ref(props.alignRight);
        const { width } = useWindowResize();
        useClickOutside(contextMenuRef, () => {
            if (props.show && !(props.attachToBody && width.value < 600)) {
                emit('onClickOutside', props.id);
            }
        });
        const updatePosition = async () => {
            canAlignTop.value = props.alignTop;
            canAlignRight.value = props.alignRight;
            if (props.show) {
                if (contextMenuFlyoutRef.value && contextMenuTriggerRef.value && props.collision === 'flip' && hasWindow()) {
                    await nextTick();
                    const flyoutRect = contextMenuFlyoutRef.value.getBoundingClientRect();
                    const triggerRect = contextMenuTriggerRef.value.getBoundingClientRect();
                    const height = getTotalHeight(props.alignTop, flyoutRect, triggerRect);
                    const width = flyoutRect.width;
                    const distanceTop = triggerRect.top;
                    const distanceBottom = window.innerHeight - triggerRect.bottom;
                    const distanceLeft = triggerRect.left;
                    const distanceRight = window.innerWidth - triggerRect.right;
                    if (props.alignTop) {
                        if (distanceTop < 0 || (triggerRect.bottom < height && distanceTop < distanceBottom)) {
                            canAlignTop.value = false;
                        }
                    }
                    else {
                        if (distanceBottom < 0 || (flyoutRect.bottom > window.innerHeight && distanceTop > distanceBottom)) {
                            canAlignTop.value = true;
                        }
                    }
                    if (props.alignRight) {
                        if (distanceLeft < 0 || (triggerRect.right < width && distanceLeft < distanceRight)) {
                            canAlignRight.value = false;
                        }
                    }
                    else {
                        if (distanceRight < 0 || (flyoutRect.right > window.innerWidth && distanceRight < distanceLeft)) {
                            canAlignRight.value = true;
                        }
                    }
                }
            }
        };
        const appendToBody = () => {
            if (props.attachToBody) {
                if (width.value < 600) {
                    document.body.appendChild(contextMenuFlyoutRef.value);
                    document.body.appendChild(contextMenuBackdropRef.value);
                }
                else {
                    contextMenuRef.value.appendChild(contextMenuFlyoutRef.value);
                    contextMenuRef.value.appendChild(contextMenuBackdropRef.value);
                }
            }
        };
        watch(() => [props.show, props.alignRight, props.alignTop, props.collision], async () => {
            updatePosition();
        });
        watch(() => [width.value], async () => {
            updatePosition();
            appendToBody();
        });
        onMounted(() => {
            appendToBody();
            updatePosition();
        });
        onUnmounted(() => {
            if (props.attachToBody) {
                document.body.contains(contextMenuFlyoutRef.value) ? document.body.removeChild(contextMenuFlyoutRef.value) : () => { };
                document.body.contains(contextMenuBackdropRef.value) ? document.body.removeChild(contextMenuBackdropRef.value) : () => { };
            }
        });
        const classes = computed(() => `${props.show ? 'ds-context-menu--active' : ''}${props.scrollable ? ' ds-context-menu--scrollable' : ''}${props.inScroll ? ' ds-context-menu--in-scroll' : ''}${canAlignRight.value ? ' ds-context-menu--align-right' : ''}${canAlignTop.value ? ' ds-context-menu--align-top' : ''}`);
        const flyoutStyles = computed(() => `${props.flyoutOffset ? `--context-menu-flyout-translate-x: ${props.flyoutOffset}` : ''}`);
        return {
            classes,
            flyoutStyles,
            canAlignRight,
            canAlignTop,
            contextMenuRef,
            contextMenuBackdropRef,
            contextMenuTriggerRef,
            contextMenuFlyoutRef
        };
    },
    emits: ['onClose', 'onActionItemClick', 'onClickOutside', 'onBackdropClick'],
    methods: {
        onClose() {
            this.$emit('onClose');
        },
        onActionItemClick(event, index) {
            event.preventDefault();
            this.$emit('onActionItemClick', index);
        },
        onBackdropClick() {
            this.$emit('onBackdropClick');
        }
    }
});

/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "contextMenuRef",
      staticClass: "ds-context-menu",
      class: _vm.classes,
      attrs: { id: _vm.id },
    },
    [
      _c("div", {
        ref: "contextMenuBackdropRef",
        staticClass: "ds-context-menu__backdrop",
        class: { "ds-context-menu__backdrop--active": _vm.show },
        attrs: { "aria-hidden": "true" },
        on: { click: _vm.onBackdropClick },
      }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "contextMenuTriggerRef", staticClass: "ds-context-menu__btn" },
        [_vm._t("trigger")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "contextMenuFlyoutRef",
          staticClass: "ds-context-menu__flyout",
          class: { "ds-context-menu__flyout--active": _vm.show },
          style: _vm.flyoutStyles,
        },
        [
          _c(
            "div",
            { staticClass: "ds-context-menu__close" },
            [_c("DsCloseButton", { on: { onClick: _vm.onClose } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ds-context-menu__body" },
            [
              _vm._t("default", function () {
                return [
                  _vm.actionItems && _vm.actionItems.length > 0
                    ? _c(
                        "ul",
                        { staticClass: "ds-context-menu__actions" },
                        _vm._l(_vm.actionItems, function (actionItem, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              staticClass: "ds-context-menu__action-item",
                              class: [
                                index === _vm.actionItems.length - 1
                                  ? "ds-context-menu__action-item--last"
                                  : "",
                                actionItem.active
                                  ? "ds-context-menu__action-item--active"
                                  : "",
                              ],
                              attrs: { "data-test": actionItem.testId },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "ds-context-menu__action-link",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onActionItemClick(
                                        $event,
                                        index
                                      )
                                    },
                                  },
                                },
                                [
                                  actionItem.icon
                                    ? _c(
                                        "i",
                                        {
                                          staticClass:
                                            "chefkoch-icons ds-context-menu__action-icon",
                                        },
                                        [_vm._v(_vm._s(actionItem.icon))]
                                      )
                                    : _vm._e(),
                                  _vm._v(_vm._s(actionItem.text)),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.$slots.footer && _vm.scrollable
            ? _c(
                "div",
                { staticClass: "ds-context-menu__footer" },
                [_vm._t("footer")],
                2
              )
            : _vm._e(),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$v = [];
__vue_render__$v._withStripped = true;

  /* style */
  const __vue_inject_styles__$v = undefined;
  /* scoped */
  const __vue_scope_id__$v = undefined;
  /* module identifier */
  const __vue_module_identifier__$v = undefined;
  /* functional template */
  const __vue_is_functional_template__$v = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$v = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
    __vue_inject_styles__$v,
    __vue_script__$v,
    __vue_scope_id__$v,
    __vue_is_functional_template__$v,
    __vue_module_identifier__$v,
    false,
    undefined,
    undefined,
    undefined
  );

var script$u = defineComponent({
    name: "DsDivider",
    props: {
        flat: Boolean,
    },
    setup(props) {
        const classes = computed(() => `${props.flat ? 'ds-divider--flat' : ''}`);
        return {
            classes,
        };
    },
});

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("hr", { staticClass: "ds-divider", class: _vm.classes })
};
var __vue_staticRenderFns__$u = [];
__vue_render__$u._withStripped = true;

  /* style */
  const __vue_inject_styles__$u = undefined;
  /* scoped */
  const __vue_scope_id__$u = undefined;
  /* module identifier */
  const __vue_module_identifier__$u = undefined;
  /* functional template */
  const __vue_is_functional_template__$u = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$u = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
    __vue_inject_styles__$u,
    __vue_script__$u,
    __vue_scope_id__$u,
    __vue_is_functional_template__$u,
    __vue_module_identifier__$u,
    false,
    undefined,
    undefined,
    undefined
  );

var script$t = defineComponent({
    name: "DsEggTimer",
    props: {
        progress: {
            type: String,
        },
        error: {
            type: Boolean,
            default: false,
        },
        paused: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const linesClasses = computed(() => `${props.error || props.paused ? 'ds-egg-timer__lines--paused' : ''}`);
        const backgroundFillColor = computed(() => `${props.error ? '#FF8B90' : '#A7C6AC'}`);
        return {
            linesClasses,
            backgroundFillColor
        };
    }
});

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$t = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "ds-egg-timer" }, [
    _vm.progress && !_vm.error
      ? _c("div", { staticClass: "ds-egg-timer__progress" }, [
          _vm._v(_vm._s(_vm.progress)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "svg",
      {
        attrs: {
          width: "800",
          height: "600",
          viewBox: "0 0 800 600",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "alpha" },
            attrs: {
              id: "egg-timer-mask",
              maskUnits: "userSpaceOnUse",
              x: "212",
              y: "84",
              width: "374",
              height: "489",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M289.54 558.66C289.54 558.66 321.9 572.09 396.78 572.09C471.66 572.09 505.6 558.66 505.6 558.66C557.72 519.91 586 452 586 374.68C586 254.19 517.24 84.24 396.75 84.24C276.26 84.24 212.9 254.24 212.9 374.68C212.93 452 239 519.91 289.54 558.66Z",
                fill: "#F3F4F0",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M628.75 236.06C472.19 215.8 442.35 180.32 330.34 91.87C218.33 3.42 28.22 130.26 104.76 271.45C181.3 412.64 547.19 500.88 630.59 468.11C764.14 415.63 785.31 256.31 628.75 236.06Z",
            fill: _vm.backgroundFillColor,
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M397.24 600C487.997 600 561.57 582.185 561.57 560.21C561.57 538.235 487.997 520.42 397.24 520.42C306.483 520.42 232.91 538.235 232.91 560.21C232.91 582.185 306.483 600 397.24 600Z",
            fill: "#BABAB7",
          },
        }),
        _vm._v(" "),
        !_vm.error
          ? _c("g", [
              _c("path", {
                attrs: {
                  d: "M630.39 88.09C638.713 88.09 645.46 81.3429 645.46 73.02C645.46 64.6971 638.713 57.95 630.39 57.95C622.067 57.95 615.32 64.6971 615.32 73.02C615.32 81.3429 622.067 88.09 630.39 88.09Z",
                  fill: "#FFDA4D",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M676.76 208C674.902 208 673.097 207.373 671.64 206.22C662.24 198.79 661.32 189.78 660.64 183.22C660.03 177.22 659.64 174.46 655.85 171.5C652.06 168.54 649.31 168.76 643.35 169.5C636.79 170.36 627.81 171.55 618.42 164.12C609.03 156.69 608.1 147.68 607.42 141.12C606.81 135.12 606.42 132.36 602.63 129.4C598.84 126.44 596.09 126.66 590.12 127.45C583.56 128.31 574.58 129.5 565.19 122.07C555.8 114.64 554.87 105.63 554.19 99.07C553.58 93.07 553.19 90.31 549.4 87.35C547.676 85.9908 546.563 84.0024 546.305 81.8223C546.047 79.6422 546.666 77.4489 548.025 75.725C549.384 74.0011 551.373 72.8877 553.553 72.6299C555.733 72.372 557.926 72.9908 559.65 74.35C569.05 81.77 569.96 90.79 570.65 97.35C571.27 103.35 571.65 106.11 575.45 109.07C579.25 112.03 581.99 111.81 587.96 111.07C594.51 110.2 603.49 109.01 612.89 116.44C622.29 123.87 623.21 132.88 623.89 139.44C624.5 145.44 624.89 148.2 628.67 151.16C632.45 154.12 635.22 153.9 641.18 153.11C647.74 152.25 656.72 151.11 666.11 158.49C675.5 165.87 676.43 174.92 677.11 181.49C677.72 187.49 678.11 190.24 681.89 193.21C683.251 194.272 684.246 195.734 684.735 197.39C685.223 199.046 685.181 200.814 684.614 202.445C684.048 204.076 682.984 205.489 681.574 206.485C680.164 207.481 678.477 208.011 676.75 208H676.76Z",
                  fill: "#FF888F",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M165.31 414.71C173.633 414.71 180.38 407.963 180.38 399.64C180.38 391.317 173.633 384.57 165.31 384.57C156.987 384.57 150.24 391.317 150.24 399.64C150.24 407.963 156.987 414.71 165.31 414.71Z",
                  fill: "#FFCD12",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M128.09 508C125.462 507.987 122.906 507.14 120.792 505.58C118.677 504.02 117.112 501.829 116.323 499.322C115.534 496.816 115.562 494.123 116.403 491.634C117.243 489.144 118.853 486.985 121 485.47L164.9 454.61C167.594 452.805 170.888 452.126 174.077 452.719C177.265 453.312 180.095 455.13 181.96 457.783C183.825 460.436 184.577 463.714 184.056 466.915C183.535 470.116 181.781 472.986 179.17 474.91V474.91L135.26 505.76C133.161 507.234 130.655 508.017 128.09 508V508Z",
                  fill: "#A7C6AC",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M113.41 423.23C110.712 423.234 108.087 422.358 105.934 420.733C103.78 419.109 102.216 416.825 101.48 414.23L86.9 362.55C86.0945 359.412 86.5484 356.083 88.1646 353.275C89.7808 350.466 92.4312 348.402 95.5494 347.521C98.6677 346.641 102.007 347.016 104.852 348.564C107.698 350.113 109.826 352.714 110.78 355.81L125.35 407.46C125.792 409.029 125.92 410.67 125.727 412.289C125.535 413.908 125.025 415.473 124.227 416.895C123.429 418.317 122.359 419.567 121.078 420.575C119.797 421.583 118.33 422.329 116.76 422.77C115.669 423.073 114.542 423.227 113.41 423.23V423.23Z",
                  fill: "#FF8B90",
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M289.54 558.66C289.54 558.66 321.9 572.09 396.78 572.09C471.66 572.09 505.6 558.66 505.6 558.66C557.72 519.91 586 452 586 374.68C586 254.19 517.24 84.24 396.75 84.24C276.26 84.24 212.9 254.24 212.9 374.68C212.93 452 239 519.91 289.54 558.66Z",
            fill: "#F3F4F0",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M214.4 405.7H584.45C584.73 402.96 584.977 400.203 585.19 397.43H213.72C213.907 400.203 214.133 402.96 214.4 405.7Z",
            fill: "#9B9A97",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M399.19 420.17L381.74 458.59H416.63L399.19 420.17Z",
            fill: "#FF6067",
          },
        }),
        _vm._v(" "),
        _vm.error
          ? _c("g", [
              _c("path", {
                attrs: {
                  d: "M484.67 67.91C485.078 66.7016 485.724 65.5867 486.568 64.6304C487.412 63.6742 488.438 62.8958 489.587 62.3406C490.735 61.7855 491.982 61.4648 493.256 61.3972C494.53 61.3297 495.804 61.5167 497.005 61.9472C498.206 62.3778 499.309 63.0433 500.249 63.905C501.19 64.7666 501.949 65.807 502.483 66.9654C503.017 68.1238 503.315 69.377 503.359 70.6518C503.403 71.9266 503.193 73.1974 502.74 74.39C502.74 74.39 502.74 74.46 502.74 74.5C501.767 76.7493 499.97 78.5412 497.719 79.5086C495.467 80.476 492.93 80.5455 490.629 79.7029C488.327 78.8603 486.435 77.1695 485.341 74.9769C484.246 72.7842 484.031 70.2559 484.74 67.91H484.67ZM524.85 12.91C523.31 17.12 518.7 26 510.4 40.2L503.31 52.86L498.16 51L500.91 36.76C503.67 20.53 505.91 10.76 507.48 6.57997C509.69 0.579973 514.09 -1.15003 519.48 0.799973C524.87 2.74997 527.09 6.88997 524.89 12.93L524.85 12.91Z",
                  fill: "#FF6067",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M217.23 155.14C214.302 152.121 212.674 148.075 212.694 143.87C212.713 139.665 214.38 135.634 217.336 132.643C220.292 129.652 224.302 127.938 228.507 127.868C232.712 127.798 236.776 129.378 239.83 132.27L239.98 132.41C242.96 135.434 244.622 139.514 244.606 143.759C244.589 148.004 242.894 152.07 239.891 155.071C236.888 158.072 232.82 159.763 228.575 159.776C224.33 159.789 220.251 158.122 217.23 155.14V155.14ZM162.08 55.26C167.39 60.57 177.7 73.87 193.33 96.49L207.54 116.19L201.04 122.69L181.35 108.45C158.65 92.79 145.47 82.45 140.16 77.15C132.54 69.53 133.09 61.64 139.83 54.91C146.57 48.18 154.46 47.64 162.08 55.26V55.26Z",
                  fill: "#595852",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M622.5 74.21C613.6 61.66 601.95 60.7001 594.5 66.0101C590.942 68.4416 588.44 72.1339 587.5 76.34C580.81 73.8 574.57 74.2 569.64 77.7C560.67 84 560.8 93 563.71 106C566.14 116.75 566.87 122.17 561.84 125.73C557.2 129.02 551.49 127.86 546.73 121.14C546.243 120.508 545.805 119.839 545.42 119.14L548.56 113.94C552.06 108.64 552.13 105.18 549.81 101.94C548.27 99.7701 545.72 98.4601 542 99.9401C535.39 104.62 535.23 115.26 542.52 125.54C551 137.54 563.17 138.98 571.26 133.25C574.65 130.957 577.042 127.461 577.95 123.47C584.24 125.85 590.42 125.78 595.54 122.15C604.23 116 604.92 107.79 601.15 92.65C599.08 83.87 598.45 77.34 603.78 73.57C608.02 70.57 613.53 71.86 618.3 78.57C618.811 79.2506 619.269 79.9694 619.67 80.72L616.46 85.81C613.03 91.21 612.96 94.67 615.21 97.81C616.82 100.09 619.38 101.39 623.1 99.95C629.71 95.23 629.79 84.49 622.5 74.21ZM576.43 103.7C574.2 94.3 573.16 87.1801 579.08 82.9801C581.364 81.4829 584.077 80.78 586.8 80.9801C586.716 85.9122 587.315 90.8322 588.58 95.6C591.21 106.21 592.24 112.46 586.58 116.44C584.209 117.997 581.416 118.786 578.58 118.7C578.525 113.627 577.802 108.584 576.43 103.7V103.7Z",
                  fill: "#FF888F",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M209.12 230.5C207.839 231.389 206.296 231.819 204.74 231.72C194.74 231.09 189.74 225.32 186.19 221.1C182.91 217.27 181.3 215.56 177.3 215.31C173.3 215.06 171.48 216.55 167.75 219.94C163.64 223.66 158.02 228.77 148.01 228.13C138 227.49 133.06 221.73 129.46 217.51C126.18 213.68 124.57 211.97 120.56 211.72C116.55 211.47 114.75 212.96 111.01 216.35C106.91 220.07 101.29 225.17 91.27 224.54C81.25 223.91 76.27 218.14 72.72 213.93C69.44 210.09 67.82 208.39 63.82 208.13C62.0432 207.942 60.4079 207.074 59.2552 205.709C58.1026 204.344 57.5218 202.586 57.634 200.803C57.7463 199.02 58.5429 197.349 59.8577 196.139C61.1724 194.929 62.9036 194.274 64.69 194.31C74.69 194.94 79.69 200.71 83.25 204.92C86.52 208.76 88.14 210.46 92.14 210.72C96.14 210.98 97.96 209.48 101.69 206.09C105.8 202.37 111.42 197.26 121.44 197.9C131.46 198.54 136.39 204.3 139.99 208.51C143.27 212.35 144.88 214.05 148.88 214.31C152.88 214.57 154.7 213.07 158.43 209.68C162.53 205.95 168.15 200.85 178.17 201.49C188.19 202.13 193.17 207.89 196.72 212.1C200 215.94 201.61 217.65 205.61 217.9C207.048 217.987 208.423 218.522 209.543 219.428C210.664 220.335 211.473 221.568 211.858 222.957C212.243 224.345 212.186 225.819 211.693 227.173C211.201 228.527 210.297 229.694 209.11 230.51L209.12 230.5Z",
                  fill: "#FFB7BA",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M84.46 347.23C89.73 361.15 100.39 364.87 108.7 361.72C112.64 360.303 115.896 357.444 117.81 353.72C123.45 357.72 129.38 358.85 134.81 356.78C144.64 353.05 146.7 344.62 147.17 331.66C147.5 321 148.17 315.75 153.71 313.66C158.85 311.66 163.91 314.18 166.71 321.66C167.009 322.384 167.253 323.13 167.44 323.89L163.24 327.99C158.67 332.11 157.77 335.33 159.14 338.99C160.05 341.4 162.14 343.24 165.95 342.79C173.28 340.01 176.01 330.08 171.7 318.68C166.7 305.42 155.7 301.08 146.7 304.48C142.992 305.819 139.922 308.504 138.1 312C132.81 308.25 127.01 306.81 121.33 309C111.71 312.65 109.06 320.18 108.9 335.28C108.71 344 107.71 350.28 101.8 352.51C97.1 354.29 92.26 351.74 89.44 344.29C89.127 343.531 88.8729 342.748 88.68 341.95L92.92 337.95C97.44 333.72 98.34 330.5 97.02 326.95C96.02 324.43 94.02 322.59 90.16 323.04C82.83 325.79 80.14 335.84 84.46 347.23ZM134.74 330.78C134.53 340.13 133.74 347.06 127.22 349.55C124.719 350.419 122.002 350.436 119.49 349.6C120.772 345 121.408 340.245 121.38 335.47C121.5 324.9 122.07 318.79 128.3 316.47C130.885 315.592 133.678 315.529 136.3 316.29C135.158 321.033 134.633 325.903 134.74 330.78V330.78Z",
                  fill: "#FF6067",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M599.67 194.7C599.496 194.218 599.359 193.723 599.26 193.22C598.724 190.531 599.279 187.739 600.802 185.458C602.325 183.178 604.691 181.596 607.38 181.06L669 168.81C671.688 168.28 674.477 168.839 676.752 170.364C679.028 171.89 680.605 174.257 681.135 176.945C681.665 179.633 681.106 182.422 679.581 184.697C678.055 186.973 675.688 188.55 673 189.08L611.42 201.34C608.991 201.824 606.469 201.42 604.312 200.201C602.156 198.983 600.509 197.031 599.67 194.7V194.7Z",
                  fill: "#BDBDB9",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M562.17 241.32C561.583 239.633 560.977 237.967 560.35 236.32L503.57 270.38L482.42 228.76H456.64L428.83 262.12L389.83 237.98L389.57 237.81L347.62 262L328.12 232.75L277.42 289.19L234.16 244.78C233.553 246.667 232.953 248.563 232.36 250.47L277.58 296.9L327.5 241.32L346 269L389.48 243.87L430 269L459.15 234H479.24L501.24 277.29L501.5 277.79L562.18 241.38L562.17 241.32Z",
                  fill: "#BABAB7",
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("g", { attrs: { mask: "url(#egg-timer-mask)" } }, [
          _c(
            "g",
            { staticClass: "ds-egg-timer__lines", class: _vm.linesClasses },
            [
              _c("svg", { attrs: { x: "-49.5%" } }, [
                _c("path", {
                  attrs: {
                    d: "M597.56 304.41C597.017 304.41 596.479 304.517 595.977 304.725C595.475 304.934 595.02 305.239 594.636 305.623C594.252 306.008 593.948 306.464 593.741 306.966C593.535 307.469 593.429 308.007 593.43 308.55V373.66C593.43 374.755 593.865 375.806 594.64 376.58C595.414 377.355 596.465 377.79 597.56 377.79C598.655 377.79 599.706 377.355 600.48 376.58C601.255 375.806 601.69 374.755 601.69 373.66V308.55C601.691 308.007 601.585 307.469 601.379 306.966C601.172 306.464 600.868 306.008 600.484 305.623C600.1 305.239 599.645 304.934 599.143 304.725C598.641 304.517 598.103 304.41 597.56 304.41V304.41Z",
                    fill: "#595852",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M557.44 341.62C556.344 341.62 555.292 342.055 554.516 342.829C553.74 343.603 553.303 344.654 553.3 345.75V373.66C553.352 374.722 553.811 375.722 554.58 376.455C555.35 377.188 556.372 377.597 557.435 377.597C558.498 377.597 559.52 377.188 560.29 376.455C561.059 375.722 561.518 374.722 561.57 373.66V345.75C561.57 344.655 561.135 343.604 560.36 342.83C559.586 342.055 558.535 341.62 557.44 341.62V341.62Z",
                    fill: "#595852",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M517.3 341.62C516.205 341.62 515.154 342.055 514.38 342.83C513.605 343.604 513.17 344.655 513.17 345.75V373.66C513.222 374.722 513.681 375.722 514.45 376.455C515.22 377.188 516.242 377.597 517.305 377.597C518.368 377.597 519.39 377.188 520.16 376.455C520.929 375.722 521.388 374.722 521.44 373.66V345.75C521.44 345.207 521.333 344.669 521.125 344.167C520.917 343.665 520.611 343.21 520.227 342.826C519.842 342.442 519.386 342.138 518.884 341.932C518.381 341.725 517.843 341.619 517.3 341.62V341.62Z",
                    fill: "#595852",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M478.2 341.62C477.105 341.62 476.054 342.055 475.28 342.83C474.505 343.604 474.07 344.655 474.07 345.75V373.66C474.122 374.722 474.581 375.722 475.35 376.455C476.12 377.188 477.142 377.597 478.205 377.597C479.268 377.597 480.29 377.188 481.06 376.455C481.829 375.722 482.288 374.722 482.34 373.66V345.75C482.34 345.207 482.233 344.669 482.025 344.167C481.816 343.665 481.511 343.21 481.127 342.826C480.742 342.442 480.286 342.138 479.784 341.932C479.281 341.725 478.743 341.619 478.2 341.62Z",
                    fill: "#595852",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M439.1 341.62C438.005 341.62 436.954 342.055 436.18 342.83C435.405 343.604 434.97 344.655 434.97 345.75V373.66C435.022 374.722 435.481 375.722 436.25 376.455C437.02 377.188 438.042 377.597 439.105 377.597C440.168 377.597 441.19 377.188 441.96 376.455C442.729 375.722 443.188 374.722 443.24 373.66V345.75C443.237 344.654 442.8 343.603 442.024 342.829C441.248 342.055 440.196 341.62 439.1 341.62Z",
                    fill: "#595852",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M400 304.41C399.457 304.41 398.919 304.517 398.417 304.725C397.915 304.934 397.46 305.239 397.076 305.623C396.692 306.008 396.388 306.464 396.182 306.966C395.975 307.469 395.869 308.007 395.87 308.55V373.66C395.87 374.755 396.305 375.806 397.08 376.58C397.854 377.355 398.905 377.79 400 377.79C401.095 377.79 402.146 377.355 402.92 376.58C403.695 375.806 404.13 374.755 404.13 373.66V308.55C404.131 308.007 404.025 307.469 403.819 306.966C403.612 306.464 403.308 306.008 402.924 305.623C402.54 305.239 402.085 304.934 401.583 304.725C401.081 304.517 400.543 304.41 400 304.41V304.41Z",
                    fill: "#595852",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M360.9 341.62C359.804 341.62 358.752 342.055 357.976 342.829C357.2 343.603 356.763 344.654 356.76 345.75V373.66C356.812 374.722 357.271 375.722 358.04 376.455C358.81 377.188 359.832 377.597 360.895 377.597C361.958 377.597 362.98 377.188 363.75 376.455C364.519 375.722 364.978 374.722 365.03 373.66V345.75C365.03 344.655 364.595 343.604 363.82 342.83C363.046 342.055 361.995 341.62 360.9 341.62V341.62Z",
                    fill: "#595852",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M320.76 341.62C319.665 341.62 318.614 342.055 317.84 342.83C317.065 343.604 316.63 344.655 316.63 345.75V373.66C316.682 374.722 317.141 375.722 317.91 376.455C318.68 377.188 319.702 377.597 320.765 377.597C321.828 377.597 322.85 377.188 323.62 376.455C324.389 375.722 324.848 374.722 324.9 373.66V345.75C324.9 345.207 324.793 344.669 324.585 344.167C324.376 343.665 324.071 343.21 323.687 342.826C323.302 342.442 322.846 342.138 322.344 341.932C321.841 341.725 321.303 341.619 320.76 341.62Z",
                    fill: "#595852",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M281.66 341.62C280.565 341.62 279.514 342.055 278.74 342.83C277.965 343.604 277.53 344.655 277.53 345.75V373.66C277.582 374.722 278.041 375.722 278.81 376.455C279.58 377.188 280.602 377.597 281.665 377.597C282.728 377.597 283.75 377.188 284.52 376.455C285.289 375.722 285.748 374.722 285.8 373.66V345.75C285.8 345.207 285.693 344.669 285.485 344.167C285.277 343.665 284.971 343.21 284.587 342.826C284.202 342.442 283.746 342.138 283.244 341.932C282.741 341.725 282.203 341.619 281.66 341.62V341.62Z",
                    fill: "#595852",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M242.22 341.62C241.677 341.619 241.139 341.725 240.636 341.932C240.134 342.138 239.678 342.442 239.293 342.826C238.909 343.21 238.604 343.665 238.395 344.167C238.187 344.669 238.08 345.207 238.08 345.75V373.66C238.132 374.722 238.591 375.722 239.36 376.455C240.13 377.188 241.152 377.597 242.215 377.597C243.278 377.597 244.3 377.188 245.07 376.455C245.839 375.722 246.298 374.722 246.35 373.66V345.75C246.35 345.208 246.243 344.671 246.036 344.17C245.828 343.668 245.524 343.213 245.14 342.83C244.757 342.446 244.302 342.142 243.8 341.934C243.299 341.727 242.762 341.62 242.22 341.62V341.62Z",
                    fill: "#595852",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M557.44 341.62C556.344 341.62 555.292 342.055 554.516 342.829C553.74 343.603 553.303 344.654 553.3 345.75V373.66C553.352 374.722 553.811 375.722 554.58 376.455C555.35 377.188 556.372 377.597 557.435 377.597C558.498 377.597 559.52 377.188 560.29 376.455C561.059 375.722 561.518 374.722 561.57 373.66V345.75C561.57 344.655 561.135 343.604 560.36 342.83C559.586 342.055 558.535 341.62 557.44 341.62V341.62Z",
                  fill: "#595852",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M517.3 341.62C516.205 341.62 515.154 342.055 514.38 342.83C513.605 343.604 513.17 344.655 513.17 345.75V373.66C513.222 374.722 513.681 375.722 514.45 376.455C515.22 377.188 516.242 377.597 517.305 377.597C518.368 377.597 519.39 377.188 520.16 376.455C520.929 375.722 521.388 374.722 521.44 373.66V345.75C521.44 345.207 521.333 344.669 521.125 344.167C520.917 343.665 520.611 343.21 520.227 342.826C519.842 342.442 519.386 342.138 518.884 341.932C518.381 341.725 517.843 341.619 517.3 341.62V341.62Z",
                  fill: "#595852",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M478.2 341.62C477.105 341.62 476.054 342.055 475.28 342.83C474.505 343.604 474.07 344.655 474.07 345.75V373.66C474.122 374.722 474.581 375.722 475.35 376.455C476.12 377.188 477.142 377.597 478.205 377.597C479.268 377.597 480.29 377.188 481.06 376.455C481.829 375.722 482.288 374.722 482.34 373.66V345.75C482.34 345.207 482.233 344.669 482.025 344.167C481.816 343.665 481.511 343.21 481.127 342.826C480.742 342.442 480.286 342.138 479.784 341.932C479.281 341.725 478.743 341.619 478.2 341.62Z",
                  fill: "#595852",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M439.1 341.62C438.005 341.62 436.954 342.055 436.18 342.83C435.405 343.604 434.97 344.655 434.97 345.75V373.66C435.022 374.722 435.481 375.722 436.25 376.455C437.02 377.188 438.042 377.597 439.105 377.597C440.168 377.597 441.19 377.188 441.96 376.455C442.729 375.722 443.188 374.722 443.24 373.66V345.75C443.237 344.654 442.8 343.603 442.024 342.829C441.248 342.055 440.196 341.62 439.1 341.62Z",
                  fill: "#595852",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M400 304.41C399.457 304.41 398.919 304.517 398.417 304.725C397.915 304.934 397.46 305.239 397.076 305.623C396.692 306.008 396.388 306.464 396.182 306.966C395.975 307.469 395.869 308.007 395.87 308.55V373.66C395.87 374.755 396.305 375.806 397.08 376.58C397.854 377.355 398.905 377.79 400 377.79C401.095 377.79 402.146 377.355 402.92 376.58C403.695 375.806 404.13 374.755 404.13 373.66V308.55C404.131 308.007 404.025 307.469 403.819 306.966C403.612 306.464 403.308 306.008 402.924 305.623C402.54 305.239 402.085 304.934 401.583 304.725C401.081 304.517 400.543 304.41 400 304.41V304.41Z",
                  fill: "#595852",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M360.9 341.62C359.804 341.62 358.752 342.055 357.976 342.829C357.2 343.603 356.763 344.654 356.76 345.75V373.66C356.812 374.722 357.271 375.722 358.04 376.455C358.81 377.188 359.832 377.597 360.895 377.597C361.958 377.597 362.98 377.188 363.75 376.455C364.519 375.722 364.978 374.722 365.03 373.66V345.75C365.03 344.655 364.595 343.604 363.82 342.83C363.046 342.055 361.995 341.62 360.9 341.62V341.62Z",
                  fill: "#595852",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M320.76 341.62C319.665 341.62 318.614 342.055 317.84 342.83C317.065 343.604 316.63 344.655 316.63 345.75V373.66C316.682 374.722 317.141 375.722 317.91 376.455C318.68 377.188 319.702 377.597 320.765 377.597C321.828 377.597 322.85 377.188 323.62 376.455C324.389 375.722 324.848 374.722 324.9 373.66V345.75C324.9 345.207 324.793 344.669 324.585 344.167C324.376 343.665 324.071 343.21 323.687 342.826C323.302 342.442 322.846 342.138 322.344 341.932C321.841 341.725 321.303 341.619 320.76 341.62Z",
                  fill: "#595852",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M281.66 341.62C280.565 341.62 279.514 342.055 278.74 342.83C277.965 343.604 277.53 344.655 277.53 345.75V373.66C277.582 374.722 278.041 375.722 278.81 376.455C279.58 377.188 280.602 377.597 281.665 377.597C282.728 377.597 283.75 377.188 284.52 376.455C285.289 375.722 285.748 374.722 285.8 373.66V345.75C285.8 345.207 285.693 344.669 285.485 344.167C285.277 343.665 284.971 343.21 284.587 342.826C284.202 342.442 283.746 342.138 283.244 341.932C282.741 341.725 282.203 341.619 281.66 341.62V341.62Z",
                  fill: "#595852",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M242.22 341.62C241.677 341.619 241.139 341.725 240.636 341.932C240.134 342.138 239.678 342.442 239.293 342.826C238.909 343.21 238.604 343.665 238.395 344.167C238.187 344.669 238.08 345.207 238.08 345.75V373.66C238.132 374.722 238.591 375.722 239.36 376.455C240.13 377.188 241.152 377.597 242.215 377.597C243.278 377.597 244.3 377.188 245.07 376.455C245.839 375.722 246.298 374.722 246.35 373.66V345.75C246.35 345.208 246.243 344.671 246.036 344.17C245.828 343.668 245.524 343.213 245.14 342.83C244.757 342.446 244.302 342.142 243.8 341.934C243.299 341.727 242.762 341.62 242.22 341.62V341.62Z",
                  fill: "#595852",
                },
              }),
            ]
          ),
        ]),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$t = [];
__vue_render__$t._withStripped = true;

  /* style */
  const __vue_inject_styles__$t = undefined;
  /* scoped */
  const __vue_scope_id__$t = undefined;
  /* module identifier */
  const __vue_module_identifier__$t = undefined;
  /* functional template */
  const __vue_is_functional_template__$t = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$t = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
    __vue_inject_styles__$t,
    __vue_script__$t,
    __vue_scope_id__$t,
    __vue_is_functional_template__$t,
    __vue_module_identifier__$t,
    false,
    undefined,
    undefined,
    undefined
  );

var script$s = defineComponent({
    name: "DsFilterChip",
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String
        },
        hasContextMenu: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        menuOpen: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
        },
    },
    emits: ['onClick'],
    setup(props, { emit }) {
        const computedTrailingIcon = computed(() => {
            if (props.hasContextMenu) {
                return '';
            }
            if (props.active) {
                return '';
            }
            return false;
        });
        const onClick = (e) => {
            emit('onClick', e);
        };
        return {
            computedTrailingIcon,
            onClick
        };
    },
});

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass: "ds-filter-chip",
      class: {
        "ds-filter-chip--active": _vm.active,
        "ds-filter-chip--has-context-menu": _vm.hasContextMenu,
        "ds-filter-chip--menu-open": _vm.menuOpen,
      },
      attrs: { "aria-label": _vm.label, id: _vm.id, disabled: _vm.disabled },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _vm.icon
        ? _c(
            "i",
            {
              staticClass:
                "ds-filter-chip__icon ds-filter-chip__icon--basic ds-filter-chip__icon--leading chefkoch-icons",
            },
            [_vm._v(_vm._s(_vm.icon))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "ds-filter-chip__label" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
      _vm._v(" "),
      _vm.computedTrailingIcon
        ? _c(
            "i",
            {
              staticClass:
                "ds-filter-chip__icon ds-filter-chip__icon--trailing chefkoch-icons",
            },
            [_vm._v(_vm._s(_vm.computedTrailingIcon))]
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$s = [];
__vue_render__$s._withStripped = true;

  /* style */
  const __vue_inject_styles__$s = undefined;
  /* scoped */
  const __vue_scope_id__$s = undefined;
  /* module identifier */
  const __vue_module_identifier__$s = undefined;
  /* functional template */
  const __vue_is_functional_template__$s = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$s = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
    __vue_inject_styles__$s,
    __vue_script__$s,
    __vue_scope_id__$s,
    __vue_is_functional_template__$s,
    __vue_module_identifier__$s,
    false,
    undefined,
    undefined,
    undefined
  );

var script$r = defineComponent({
    name: "DsOverlay",
    components: {
        DsButton: __vue_component__$H,
        DsButtonBox: __vue_component__$G,
        DsCloseButton: __vue_component__$F,
    },
    props: {
        overlayId: {
            type: String,
            required: true,
            default: 'modal',
        },
        size: {
            type: String,
            enum: ['default', 'large', 'xlarge', 'fullscreen'],
            default: 'default',
        },
        title: {
            type: String,
        },
        show: {
            required: true,
            type: Boolean,
            default: false
        },
        closeOnEscape: {
            type: Boolean,
            default: true
        },
        hideCloseButton: {
            type: Boolean,
            default: false
        },
        footerShadow: {
            type: Boolean,
            default: false
        },
        centeredMobile: {
            type: Boolean,
            default: false
        },
        noHead: {
            type: Boolean,
            default: false
        },
        noFooter: {
            type: Boolean,
            default: false
        },
        overlayClasses: String,
        primaryDisabled: Boolean,
        primaryLabel: String,
        secondaryLabel: String,
        tertiaryLabel: String,
        primaryMode: {
            type: String,
            default: 'primary',
            enum: ['primary', 'danger']
        },
    },
    setup(props, { emit }) {
        const overlayInnerRef = ref(null);
        useClickOutside(overlayInnerRef, () => {
            if (props.show) {
                emit('onBackdropClick', props.overlayId);
            }
        });
        const onClose = () => {
            emit('onClose', props.overlayId);
        };
        const { attachEscapeKeyHandler, removeEscapeKeyHandler } = useEscapeKey(onClose);
        const classes = computed(() => `${props.overlayClasses || ''}${props.size !== 'default' ? ` ds-overlay--${props.size}` : ''}`);
        const contentClasses = computed(() => `${props.noHead ? 'ds-overlay__content--no-head' : ''}${props.centeredMobile ? ' ds-text-center-to-xs' : ''}`);
        const overlayTitleId = computed(() => `${props.overlayId}-title`);
        const hasSecondary = computed(() => props.secondaryLabel ? true : false);
        const hasTertiary = computed(() => props.tertiaryLabel ? true : false);
        onMounted(attachEscapeKeyHandler);
        onUnmounted(removeEscapeKeyHandler);
        watch(() => [props.show, props.closeOnEscape], async () => {
            if (props.show && props.closeOnEscape) {
                attachEscapeKeyHandler();
            }
            else {
                removeEscapeKeyHandler();
            }
        });
        return {
            classes,
            contentClasses,
            overlayTitleId,
            hasSecondary,
            hasTertiary,
            onClose,
            overlayInnerRef
        };
    },
    methods: {
        onPrimaryClick() {
            this.$emit('onPrimaryClick', this.overlayId);
        },
        onSecondaryClick() {
            this.$emit('onSecondaryClick', this.overlayId);
        },
        onTertiaryClick() {
            this.$emit('onTertiaryClick', this.overlayId);
        },
    },
});

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$r = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { name: "ds-overlay-fade" } }, [
    _vm.show
      ? _c("div", { staticClass: "ds-overlay-backdrop" }, [
          _c(
            "div",
            {
              staticClass: "ds-overlay",
              class: _vm.classes,
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": _vm.overlayTitleId,
              },
            },
            [
              _c(
                "div",
                { ref: "overlayInnerRef", staticClass: "ds-overlay__inner" },
                [
                  !_vm.hideCloseButton
                    ? _c(
                        "div",
                        { staticClass: "ds-overlay__close" },
                        [_c("DsCloseButton", { on: { onClick: _vm.onClose } })],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ds-overlay__content",
                      class: _vm.contentClasses,
                    },
                    [
                      !_vm.noHead
                        ? _c(
                            "div",
                            { staticClass: "ds-overlay__head" },
                            [
                              _vm._t("head", function () {
                                return [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "ds-overlay__title ds-text-sans",
                                      attrs: { id: _vm.overlayTitleId },
                                    },
                                    [_vm._v(_vm._s(_vm.title))]
                                  ),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ds-overlay__body" },
                        [_vm._t("default")],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.noFooter
                        ? _c(
                            "div",
                            {
                              staticClass: "ds-overlay__footer",
                              class: {
                                "ds-overlay__footer--shadow": _vm.footerShadow,
                              },
                            },
                            [
                              _vm._t("footer", function () {
                                return [
                                  _c("ds-button-box", {
                                    attrs: {
                                      stackedMobile: _vm.centeredMobile,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.hasSecondary
                                          ? {
                                              key: "first",
                                              fn: function () {
                                                return [
                                                  _c("ds-button", {
                                                    attrs: {
                                                      label: _vm.secondaryLabel,
                                                      mode: "secondary",
                                                    },
                                                    on: {
                                                      onClick:
                                                        _vm.onSecondaryClick,
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                        {
                                          key: "second",
                                          fn: function () {
                                            return [
                                              _c("ds-button", {
                                                attrs: {
                                                  label: _vm.primaryLabel,
                                                  mode: _vm.primaryMode,
                                                  disabled: _vm.primaryDisabled,
                                                },
                                                on: {
                                                  onClick: _vm.onPrimaryClick,
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        _vm.hasTertiary
                                          ? {
                                              key: "third",
                                              fn: function () {
                                                return [
                                                  _c("ds-button", {
                                                    attrs: {
                                                      label: _vm.tertiaryLabel,
                                                      mode: "tertiary",
                                                      flat: "",
                                                    },
                                                    on: {
                                                      onClick:
                                                        _vm.onTertiaryClick,
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$r = [];
__vue_render__$r._withStripped = true;

  /* style */
  const __vue_inject_styles__$r = function (inject) {
    if (!inject) return
    inject("data-v-d479f6b4_0", { source: "\n.ds-overlay-fade-enter,\n.ds-overlay-fade-enter-from,\n.ds-overlay-fade-leave-to {\n  opacity: 0;\n}\n.ds-overlay-fade-enter-active,\n.ds-overlay-fade-leave-active {\n  transition: opacity .5s ease;\n}\n", map: {"version":3,"sources":["/builds/dev/dsy/packages/dsy-vue/src/components/DsOverlay/DsOverlay.vue"],"names":[],"mappings":";AAmLA;;;EAGA,UAAA;AACA;AAEA;;EAEA,4BAAA;AACA","file":"DsOverlay.vue","sourcesContent":["<template>\n  <transition name=\"ds-overlay-fade\">\n    <div class=\"ds-overlay-backdrop\" v-if=\"show\">\n      <div role=\"dialog\" aria-modal=\"true\" :aria-labelledby=\"overlayTitleId\"\n        class=\"ds-overlay\"\n        :class=\"classes\"\n      >\n        <div class=\"ds-overlay__inner\" ref=\"overlayInnerRef\">\n          <div class=\"ds-overlay__close\" v-if=\"!hideCloseButton\">\n            <DsCloseButton @onClick=\"onClose\"/>\n          </div>\n          <div class=\"ds-overlay__content\" :class=\"contentClasses\">\n            <div class=\"ds-overlay__head\" v-if=\"!noHead\">\n              <slot name=\"head\">\n                <h4 class=\"ds-overlay__title ds-text-sans\" :id=\"overlayTitleId\">{{title}}</h4>\n              </slot>\n            </div>\n            <div class=\"ds-overlay__body\">\n              <slot></slot>\n            </div>\n            <div class=\"ds-overlay__footer\" :class=\"{'ds-overlay__footer--shadow': footerShadow}\" v-if=\"!noFooter\">\n              <slot name=\"footer\">\n                <ds-button-box :stackedMobile=\"centeredMobile\">\n                  <template v-slot:first v-if=\"hasSecondary\">\n                    <ds-button @onClick=\"onSecondaryClick\" :label=\"secondaryLabel\" mode=\"secondary\"/>\n                  </template>\n                  <template v-slot:second>\n                    <ds-button @onClick=\"onPrimaryClick\" :label=\"primaryLabel\" :mode=\"primaryMode\" :disabled=\"primaryDisabled\"/>\n                  </template>\n                  <template v-slot:third v-if=\"hasTertiary\">\n                    <ds-button @onClick=\"onTertiaryClick\" :label=\"tertiaryLabel\" mode=\"tertiary\" flat />\n                  </template>\n                </ds-button-box>\n              </slot>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </transition>\n</template>\n\n<script lang=\"ts\">\nimport { computed, defineComponent, ref, onMounted, Ref, watch, onUnmounted } from '@vue/composition-api';\nimport { useClickOutside, useEscapeKey } from \"../../composables\";\nimport DsButton from '../DsButton';\nimport DsButtonBox from '../DsButtonBox';\nimport DsCloseButton from \"../DsCloseButton\";\n\nexport default defineComponent({\n  name: \"DsOverlay\",\n  components: {\n    DsButton,\n    DsButtonBox,\n    DsCloseButton,\n  },\n  props: {\n    overlayId: {\n      type: String,\n      required: true,\n      default: 'modal',\n    },\n    size: {\n      type: String,\n      enum: ['default', 'large', 'xlarge', 'fullscreen'],\n      default: 'default',\n    },\n    title: {\n      type: String,\n    },\n    show: {\n      required: true,\n      type: Boolean,\n      default: false\n    },\n    closeOnEscape: {\n      type: Boolean,\n      default: true\n    },\n    hideCloseButton: {\n      type: Boolean,\n      default: false\n    },\n    footerShadow: {\n      type: Boolean,\n      default: false\n    },\n    centeredMobile: {\n      type: Boolean,\n      default: false\n    },\n    noHead: {\n      type: Boolean,\n      default: false\n    },\n    noFooter: {\n      type: Boolean,\n      default: false\n    },\n    overlayClasses: String,\n    primaryDisabled: Boolean,\n    primaryLabel: String,\n    secondaryLabel: String,\n    tertiaryLabel: String,\n    primaryMode: {\n      type: String,\n      default: 'primary',\n      enum: ['primary', 'danger']\n    },\n  },\n  setup(props, {emit}) {\n    const overlayInnerRef:Ref = ref(null);\n\n    useClickOutside(overlayInnerRef, () => {\n      if(props.show) {\n        emit('onBackdropClick', props.overlayId);\n      }\n    });\n\n    const onClose = () => {\n      emit('onClose', props.overlayId);\n    };\n\n    const { attachEscapeKeyHandler, removeEscapeKeyHandler} = useEscapeKey(onClose);\n\n    const classes = computed(\n      (): string => `${props.overlayClasses || ''}${props.size !== 'default' ? ` ds-overlay--${props.size}`: ''}`\n    );\n    const contentClasses = computed(\n      (): string => `${props.noHead? 'ds-overlay__content--no-head': ''}${props.centeredMobile? ' ds-text-center-to-xs': ''}`\n    );\n    const overlayTitleId = computed(\n      (): string => `${props.overlayId}-title`\n    );\n\n    const hasSecondary = computed(\n      (): boolean => props.secondaryLabel ? true: false\n    );\n\n    const hasTertiary = computed(\n      (): boolean => props.tertiaryLabel ? true: false\n    );\n \n    onMounted(attachEscapeKeyHandler);\n    onUnmounted(removeEscapeKeyHandler);\n\n    watch(() => [props.show, props.closeOnEscape], async () => {\n      if(props.show && props.closeOnEscape){\n        attachEscapeKeyHandler();\n      } else {\n        removeEscapeKeyHandler();\n      }\n    });\n\n    return {\n      classes,\n      contentClasses,\n      overlayTitleId,\n      hasSecondary,\n      hasTertiary,\n      onClose,\n      overlayInnerRef\n    };\n  },\n  methods: {\n    onPrimaryClick() {\n      this.$emit('onPrimaryClick', this.overlayId)\n    },\n    onSecondaryClick() {\n      this.$emit('onSecondaryClick', this.overlayId)\n    },\n    onTertiaryClick() {\n      this.$emit('onTertiaryClick', this.overlayId)\n    },\n  },\n});\n</script>\n\n<style>\n  .ds-overlay-fade-enter,\n  .ds-overlay-fade-enter-from,\n  .ds-overlay-fade-leave-to {\n    opacity: 0;\n  }\n\n  .ds-overlay-fade-enter-active,\n  .ds-overlay-fade-leave-active {\n    transition: opacity .5s ease;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$r = undefined;
  /* module identifier */
  const __vue_module_identifier__$r = undefined;
  /* functional template */
  const __vue_is_functional_template__$r = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$r = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
    __vue_inject_styles__$r,
    __vue_script__$r,
    __vue_scope_id__$r,
    __vue_is_functional_template__$r,
    __vue_module_identifier__$r,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$q = defineComponent({
    name: "DsFullscreenOverlay",
    components: {
        DsOverlay: __vue_component__$r,
    },
    props: {
        overlayId: {
            type: String,
            required: true,
            default: 'fullscreen-modal',
        },
        show: {
            required: true,
            type: Boolean,
            default: false
        },
        closeOnEscape: {
            type: Boolean,
            default: true
        },
    },
    emits: ['onClose'],
    setup(props, { emit }) {
        const onClose = () => {
            emit('onClose', props.overlayId);
        };
        return {
            onClose
        };
    }
});

/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "DsOverlay",
    {
      attrs: {
        noFooter: "",
        overlayId: _vm.overlayId,
        show: _vm.show,
        size: "fullscreen",
      },
      on: { onClose: _vm.onClose },
      scopedSlots: _vm._u([
        {
          key: "head",
          fn: function () {
            return [
              _c("div", { staticClass: "ds-overlay__logo" }, [
                _c("img", {
                  attrs: {
                    src: "https://img.chefkoch-cdn.de/assets/v2/img/ci/CK-Logo.svg",
                    width: "220",
                    height: "48",
                  },
                }),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [_vm._v(" "), _vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$q = [];
__vue_render__$q._withStripped = true;

  /* style */
  const __vue_inject_styles__$q = undefined;
  /* scoped */
  const __vue_scope_id__$q = undefined;
  /* module identifier */
  const __vue_module_identifier__$q = undefined;
  /* functional template */
  const __vue_is_functional_template__$q = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$q = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
    __vue_inject_styles__$q,
    __vue_script__$q,
    __vue_scope_id__$q,
    __vue_is_functional_template__$q,
    __vue_module_identifier__$q,
    false,
    undefined,
    undefined,
    undefined
  );

var script$p = defineComponent({
    name: "DsHorizontalScroll",
    props: {
        disableGradient: {
            type: Boolean,
            default: false,
        },
        initiallyScrollRight: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const scrollRef = ref();
        const isScrollable = ref(false);
        let observer;
        const { scrollState } = useScroll(scrollRef);
        const leftGradientVisible = computed(() => {
            if (isScrollable.value && !scrollState.left) {
                return true;
            }
            return false;
        });
        const rightGradientVisible = computed(() => {
            if (isScrollable.value && !scrollState.right) {
                return true;
            }
            return false;
        });
        const updateScrollable = (entries) => {
            const el = entries[0].target;
            el.dispatchEvent(new Event('scroll'));
            if (el.scrollWidth > el.clientWidth) {
                isScrollable.value = true;
            }
        };
        if (hasWindow()) {
            onMounted(() => {
                observer = new ResizeObserver(updateScrollable);
                if (scrollRef.value) {
                    observer.observe(scrollRef.value);
                    if (props.initiallyScrollRight) {
                        scrollRef.value.scrollLeft = scrollRef.value.scrollWidth;
                    }
                }
            });
            onUnmounted(() => {
                observer && observer.disconnect();
            });
        }
        return {
            leftGradientVisible,
            rightGradientVisible,
            scrollRef,
        };
    },
});

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-h-scroll-wrap",
      class: {
        "ds-h-scroll-wrap--gradient-left":
          _vm.leftGradientVisible && !_vm.disableGradient,
        "ds-h-scroll-wrap--gradient-right":
          _vm.rightGradientVisible && !_vm.disableGradient,
      },
    },
    [
      _c(
        "div",
        { ref: "scrollRef", staticClass: "ds-h-scroll" },
        [_vm._t("default")],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$p = [];
__vue_render__$p._withStripped = true;

  /* style */
  const __vue_inject_styles__$p = undefined;
  /* scoped */
  const __vue_scope_id__$p = undefined;
  /* module identifier */
  const __vue_module_identifier__$p = undefined;
  /* functional template */
  const __vue_is_functional_template__$p = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$p = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
    __vue_inject_styles__$p,
    __vue_script__$p,
    __vue_scope_id__$p,
    __vue_is_functional_template__$p,
    __vue_module_identifier__$p,
    false,
    undefined,
    undefined,
    undefined
  );

var script$o = defineComponent({
    name: "DsInfobox",
    components: { DsCloseButton: __vue_component__$F },
    props: {
        alignImageTop: {
            type: Boolean,
            default: false,
        },
        closable: {
            type: Boolean,
            default: false,
        },
        copy: {
            type: String,
        },
        id: {
            type: String,
        },
        imageAlt: {
            type: String,
        },
        imageUrl: {
            type: String
        },
        mobileCentered: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        }
    },
    emits: ['onClose'],
    setup(props, { emit }) {
        const onClose = () => {
            emit('onClose', props.id);
        };
        return {
            onClose
        };
    }
});

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-infobox",
      class: { "ds-infobox--closable": _vm.closable },
    },
    [
      _vm.closable
        ? _c(
            "div",
            { staticClass: "ds-infobox__close" },
            [_c("DsCloseButton", { on: { onClick: _vm.onClose } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.imageUrl || _vm.$slots.image
        ? _c(
            "div",
            {
              staticClass: "ds-infobox__img-wrap",
              class: { "ds-infobox__img-wrap--top": _vm.alignImageTop },
            },
            [
              _vm.imageUrl
                ? _c("img", {
                    staticClass: "ds-infobox__img",
                    attrs: { alt: _vm.imageAlt, src: _vm.imageUrl },
                  })
                : _vm._t("image"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ds-infobox__content",
          class: {
            "ds-infobox__content--mobile-left-aligned": !_vm.mobileCentered,
          },
        },
        [
          _vm.title
            ? _c(
                "h3",
                { staticClass: "ds-infobox__title ds-text-corporate-green" },
                [_vm._v(_vm._s(_vm.title))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.copy
            ? _c("div", { staticClass: "ds-infobox__copy" }, [
                _vm._v(_vm._s(_vm.copy)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.more
            ? [
                _c(
                  "div",
                  { staticClass: "ds-infobox__more" },
                  [_vm._t("more")],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$o = [];
__vue_render__$o._withStripped = true;

  /* style */
  const __vue_inject_styles__$o = undefined;
  /* scoped */
  const __vue_scope_id__$o = undefined;
  /* module identifier */
  const __vue_module_identifier__$o = undefined;
  /* functional template */
  const __vue_is_functional_template__$o = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$o = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
    __vue_inject_styles__$o,
    __vue_script__$o,
    __vue_scope_id__$o,
    __vue_is_functional_template__$o,
    __vue_module_identifier__$o,
    false,
    undefined,
    undefined,
    undefined
  );

var script$n = defineComponent({
    name: "DsInlineNotification",
    components: {
        DsButton: __vue_component__$H,
        DsCloseButton: __vue_component__$F,
    },
    emits: ['onButtonClick', 'onClose'],
    props: {
        buttonLabel: String,
        closable: Boolean,
        copy: {
            type: String,
            required: true,
        },
        mode: {
            type: String,
            enum: [
                'info',
                'success',
                'warning',
                'danger',
            ],
            default: 'info'
        },
        title: String,
    },
    setup(props, { emit }) {
        const classes = computed(() => {
            return `ds-notification--${props.mode}`;
        });
        const onButtonClick = (event) => {
            emit('onButtonClick', event);
        };
        const onClose = (event) => {
            emit('onClose', event);
        };
        return {
            classes,
            onButtonClick,
            onClose,
        };
    }
});

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-notification",
      class: [{ "ds-notification--closable": _vm.closable }, _vm.classes],
    },
    [
      _vm.closable
        ? _c(
            "div",
            { staticClass: "ds-notification__close" },
            [_c("DsCloseButton", { on: { onClick: _vm.onClose } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.title
        ? _c("h4", { staticClass: "ds-notification__title ds-text-sans" }, [
            _vm._v(_vm._s(_vm.title)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ds-notification__body" }, [
        _vm._v(_vm._s(_vm.copy)),
      ]),
      _vm._v(" "),
      _vm.buttonLabel
        ? _c(
            "div",
            { staticClass: "ds-notification__btn" },
            [
              _c("DsButton", {
                attrs: { mode: "tertiary", flat: "", label: _vm.buttonLabel },
                on: { onClick: _vm.onButtonClick },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$n = [];
__vue_render__$n._withStripped = true;

  /* style */
  const __vue_inject_styles__$n = undefined;
  /* scoped */
  const __vue_scope_id__$n = undefined;
  /* module identifier */
  const __vue_module_identifier__$n = undefined;
  /* functional template */
  const __vue_is_functional_template__$n = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$n = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    false,
    undefined,
    undefined,
    undefined
  );

var script$m = defineComponent({
    name: "DsInputChip",
    props: {
        id: {
            type: String
        },
        label: {
            type: String,
            required: true
        }
    },
    emits: ['onClick'],
    setup(props, { emit }) {
        const onClick = (e) => {
            emit('onClick', e);
        };
        return {
            onClick
        };
    },
});

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-input-chip",
      attrs: { "aria-label": _vm.label, id: _vm.id },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _c("span", { staticClass: "ds-input-chip__label" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
      _vm._v(" "),
      _c(
        "i",
        {
          staticClass:
            "ds-input-chip__icon ds-input-chip__icon--trailing chefkoch-icons",
        },
        [_vm._v("")]
      ),
    ]
  )
};
var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;

  /* style */
  const __vue_inject_styles__$m = undefined;
  /* scoped */
  const __vue_scope_id__$m = undefined;
  /* module identifier */
  const __vue_module_identifier__$m = undefined;
  /* functional template */
  const __vue_is_functional_template__$m = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$m = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    false,
    undefined,
    undefined,
    undefined
  );

var script$l = defineComponent({
    name: "DsLoadingOverlay",
    components: { DsEggTimer: __vue_component__$t, DsOverlay: __vue_component__$r },
    props: {
        headline: String,
        show: {
            required: true,
            type: Boolean,
            default: false
        },
        closable: {
            type: Boolean,
            default: false,
        },
        progress: {
            type: String,
        },
        error: {
            type: Boolean,
            default: false,
        },
        paused: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const classes = computed(() => `ds-overlay--loader${props.closable ? ' ds-overlay--closable' : ''}`);
        return {
            classes
        };
    },
    methods: {
        onClose(overlayId) {
            this.$emit('onClose', overlayId);
        },
        onBackdropClick(overlayId) {
            this.$emit('onBackdropClick', overlayId);
        }
    }
});

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ds-overlay",
    {
      attrs: {
        "no-head": "",
        "hide-close-button": !_vm.closable,
        "no-footer": "",
        "overlay-id": "loading-overlay",
        show: _vm.show,
        "overlay-classes": _vm.classes,
      },
      on: { onClose: _vm.onClose, onBackdropClick: _vm.onBackdropClick },
    },
    [
      _c(
        "div",
        { staticClass: "ds-overlay__loader" },
        [
          _c("ds-egg-timer", {
            attrs: {
              progress: _vm.progress,
              error: _vm.error,
              paused: _vm.paused,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.headline
        ? _c("h3", { staticClass: "ds-overlay__headline ds-text-sans" }, [
            _vm._v(_vm._s(_vm.headline)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
};
var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;

  /* style */
  const __vue_inject_styles__$l = undefined;
  /* scoped */
  const __vue_scope_id__$l = undefined;
  /* module identifier */
  const __vue_module_identifier__$l = undefined;
  /* functional template */
  const __vue_is_functional_template__$l = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$l = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    false,
    undefined,
    undefined,
    undefined
  );

var script$k = defineComponent({
    name: "DsPromotionTeaser",
    components: {
        DsPlusBadge: __vue_component__$L
    },
    props: {
        centerContent: {
            type: Boolean,
            default: false,
        },
        claim: {
            type: String,
        },
        headline: {
            type: String,
        },
        href: {
            type: String,
            default: '#'
        },
        imgSrc: {
            type: String,
            required: true,
        },
        imgSrcHiRes: {
            type: String,
            required: true,
        },
        large: {
            type: Boolean,
            default: false,
        },
        linkTitle: {
            type: String,
            required: false,
        },
        showPlusBadge: {
            type: Boolean,
        },
        showPlusLogo: {
            type: Boolean,
        },
        type: {
            type: String,
            enum: [
                'card',
                'banner',
            ],
            default: 'card',
        },
    },
    emits: ['onClick'],
    setup(props, { emit }) {
        const onClick = (event) => {
            emit('onClick', event);
        };
        const modifierClass = computed(() => {
            return `ds-promotion-teaser--${props.type}`;
        });
        const srcSet = computed(() => {
            return `${props.imgSrc} 1x, ${props.imgSrcHiRes} 2x`;
        });
        return {
            modifierClass,
            onClick,
            srcSet
        };
    },
});

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "a",
    {
      staticClass: "ds-teaser-link",
      attrs: { href: _vm.href, title: _vm.linkTitle },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "ds-promotion-teaser",
          class: [
            {
              "ds-promotion-teaser--banner": _vm.type === "banner",
              "ds-promotion-teaser--large": _vm.type === "banner" && _vm.large,
            },
            _vm.modifierClass,
          ],
        },
        [
          _c(
            "div",
            {
              staticClass:
                "ds-promotion-teaser__image-wrap ds-teaser-link__image-wrap",
            },
            [
              _c("img", {
                staticClass: "ds-teaser-link__image",
                attrs: { src: _vm.imgSrc, srcset: _vm.srcSet },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ds-promotion-teaser__content",
              class: {
                "ds-promotion-teaser__content--centered": _vm.centerContent,
              },
            },
            [
              _vm.$slots.logo || _vm.showPlusBadge || _vm.showPlusLogo
                ? _c(
                    "div",
                    { staticClass: "ds-promotion-teaser__logo" },
                    [
                      _vm.$slots.logo
                        ? [_vm._t("logo")]
                        : [
                            _vm.showPlusBadge && !_vm.showPlusLogo
                              ? _c("DsPlusBadge")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showPlusLogo
                              ? _c("img", {
                                  attrs: {
                                    src: "https://img.chefkoch-cdn.de/assets/v2/img/ci/CK-Plus-blackberry.svg",
                                    height: "32",
                                    alt: "PLUS Logo",
                                  },
                                })
                              : _vm._e(),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.headline
                ? _c("h4", { staticClass: "ds-promotion-teaser__headline" }, [
                    _vm._v("\n        " + _vm._s(_vm.headline) + "\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim
                ? _c("p", { staticClass: "ds-promotion-teaser__claim" }, [
                    _vm._v(_vm._s(_vm.claim)),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;

  /* style */
  const __vue_inject_styles__$k = undefined;
  /* scoped */
  const __vue_scope_id__$k = undefined;
  /* module identifier */
  const __vue_module_identifier__$k = undefined;
  /* functional template */
  const __vue_is_functional_template__$k = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$k = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    false,
    undefined,
    undefined,
    undefined
  );

var script$j = defineComponent({
    name: "DsQuantityControl",
    components: {
        DsButton: __vue_component__$H
    },
    emits: ['onInput', 'onStepDown', 'onStepUp'],
    props: {
        ariaLabel: {
            type: String,
            default: 'Anzahl'
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            required: true,
        },
        initialValue: {
            type: Number,
            default: 1,
        },
        inputReadonly: {
            type: Boolean,
            default: false,
        },
        min: {
            type: Number,
            default: 1,
        },
        max: {
            type: Number,
            default: 999
        },
        step: {
            type: Number,
            default: 1,
        },
    },
    setup(props, { emit }) {
        const value = ref(props.initialValue);
        const inputRef = ref();
        const inputClasses = computed(() => {
            return `${props.hasError ? 'ds-input--error' : ''}`;
        });
        const downBtnDisabled = computed(() => {
            if (!isNaN(value.value)) {
                return value.value <= props.min;
            }
            return false;
        });
        const upBtnDisabled = computed(() => {
            if (!isNaN(value.value)) {
                return value.value >= props.max;
            }
            return false;
        });
        const onControlClick = (direction) => {
            if (inputRef.value) {
                if (direction === 'up') {
                    inputRef.value.stepUp();
                    emit('onStepUp', props.id);
                }
                if (direction === 'down') {
                    inputRef.value.stepDown();
                    emit('onStepDown', props.id);
                }
                inputRef.value.dispatchEvent(new Event('input'));
            }
        };
        const onInput = (event) => {
            const parsedValue = parseFloat((event.target).value);
            if (!isNaN(parsedValue)) {
                value.value = parsedValue;
                emit('onInput', props.id, value.value);
            }
        };
        return {
            downBtnDisabled,
            inputClasses,
            inputRef,
            upBtnDisabled,
            value,
            onControlClick,
            onInput
        };
    },
});

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "ds-quantity-control" }, [
    _c(
      "div",
      { staticClass: "ds-quantity-control__down" },
      [
        _c("DsButton", {
          attrs: { mode: "control", icon: "", disabled: _vm.downBtnDisabled },
          on: {
            onClick: function ($event) {
              return _vm.onControlClick("down")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ds-quantity-control__input-wrap" }, [
      _c("input", {
        ref: "inputRef",
        staticClass: "ds-quantity-control__input ds-input",
        class: _vm.inputClasses,
        attrs: {
          "aria-label": _vm.ariaLabel,
          type: "number",
          id: _vm.id,
          min: _vm.min,
          max: _vm.max,
          name: _vm.id,
          step: _vm.step,
          readonly: _vm.inputReadonly,
        },
        domProps: { value: _vm.value },
        on: { input: _vm.onInput },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ds-quantity-control__up" },
      [
        _c("DsButton", {
          attrs: { mode: "control", icon: "", disabled: _vm.upBtnDisabled },
          on: {
            onClick: function ($event) {
              return _vm.onControlClick("up")
            },
          },
        }),
      ],
      1
    ),
  ])
};
var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;

  /* style */
  const __vue_inject_styles__$j = undefined;
  /* scoped */
  const __vue_scope_id__$j = undefined;
  /* module identifier */
  const __vue_module_identifier__$j = undefined;
  /* functional template */
  const __vue_is_functional_template__$j = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$j = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    undefined,
    undefined,
    undefined
  );

var script$i = defineComponent({
    name: "DsRadioButton",
    props: {
        checked: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        },
        id: {
            type: String
        },
        label: {
            type: String
        },
        name: {
            type: String
        },
        value: {
            type: [Number, String]
        }
    },
    emits: ['onChange'],
    setup(props, { emit }) {
        const { computedId } = useComputedId(props);
        const onChange = (e) => {
            emit('onChange', e.target.value);
        };
        return {
            computedId,
            onChange
        };
    },
});

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "ds-choice" }, [
    _c("input", {
      staticClass: "ds-choice__input",
      attrs: {
        disabled: _vm.disabled,
        id: _vm.computedId,
        name: _vm.name,
        type: "radio",
      },
      domProps: { checked: _vm.checked, value: _vm.value },
      on: { change: _vm.onChange },
    }),
    _vm._v(" "),
    _c(
      "i",
      { staticClass: "chefkoch-icons ds-choice__icon ds-choice__icon--active" },
      [_vm._v("\n    \n  ")]
    ),
    _vm._v(" "),
    _c(
      "i",
      {
        staticClass: "chefkoch-icons ds-choice__icon ds-choice__icon--inactive",
      },
      [_vm._v("\n    \n  ")]
    ),
    _vm._v(" "),
    _vm.label
      ? _c(
          "label",
          { staticClass: "ds-choice__label", attrs: { for: _vm.computedId } },
          [
            _vm.$slots.beforeLabel
              ? [
                  _c(
                    "span",
                    { staticClass: "ds-choice__label-slot" },
                    [_vm._t("beforeLabel")],
                    2
                  ),
                ]
              : _vm._e(),
            _vm._v(_vm._s(_vm.label)),
          ],
          2
        )
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;

  /* style */
  const __vue_inject_styles__$i = undefined;
  /* scoped */
  const __vue_scope_id__$i = undefined;
  /* module identifier */
  const __vue_module_identifier__$i = undefined;
  /* functional template */
  const __vue_is_functional_template__$i = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$i = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    undefined,
    undefined,
    undefined
  );

var script$h = defineComponent({
    name: "DsRangeSlider",
    emits: ['onInput'],
    props: {
        fluid: {
            type: Boolean,
            default: false,
        },
        noFill: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Number,
            default: 1,
        },
        min: {
            type: Number,
            default: 1,
        },
        max: {
            type: Number,
            default: 5
        },
        step: {
            type: Number,
            default: 1,
        },
        scaleItems: {
            type: Array,
            required: true,
        }
    },
    setup(props) {
        const slider = ref("range-slider");
        const value = ref(props.initialValue);
        const trackBackground = computed(() => {
            const progress = (value.value - props.min) / (props.max - props.min) * 100;
            return `linear-gradient(to right, transparent 0%, transparent calc(0% + 10px), var(--range-slider-track-fill-color) calc(0% + 10px), var(--range-slider-track-fill-color) ${progress}%, var(--range-slider-track-inactive-color) ${progress}%, var(--range-slider-track-inactive-color) calc(100% - 10px), transparent calc(100% - 10px), transparent 100%)`;
        });
        const inputWidth = computed(() => {
            if (props.min > 1) {
                return `calc(${(props.max - props.min) / (props.max - 1) * 100}% + ${24 - 24 * (props.max - props.min) / (props.max - 1)}px)`;
            }
            if (props.max < 5) {
                return `calc(${(props.max - 1) / (props.scaleItems.length - 1) * 100}% + ${24 - 24 * (props.max - 1) / (props.scaleItems.length - 1)}px)`;
            }
            return '';
        });
        const leftPosition = computed(() => {
            if (props.min > 1) {
                return `calc(${(props.min - 1) / (props.scaleItems.length - 1) * 100}% - ${24 - 24 * (props.scaleItems.length - props.min) / (props.scaleItems.length - 1)}px)`;
            }
            return '';
        });
        const classes = computed(() => `${props.fluid ? 'ds-range-slider--fluid' : ''}${props.noFill ? ' ds-range-slider--no-fill' : ''}`);
        const hasDisabledTrack = computed(() => props.max < props.scaleItems.length || props.min > 1);
        return {
            value,
            slider,
            trackBackground,
            inputWidth,
            leftPosition,
            classes,
            hasDisabledTrack
        };
    },
    methods: {
        onInput(event) {
            this.value = parseFloat((event.target).value);
            this.$emit('onInput', this.value);
        },
        isDisabledScaleItem(index) {
            return (this.max < (index + 1)) || (this.min > (index + 1));
        }
    }
});

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "ds-range-slider", class: _vm.classes }, [
    _c("div", { staticClass: "ds-range-slider__input-wrap" }, [
      _c("input", {
        staticClass: "ds-range-slider__input",
        style: {
          background: _vm.trackBackground,
          width: _vm.inputWidth,
          left: _vm.leftPosition,
        },
        attrs: { type: "range", step: _vm.step, min: _vm.min, max: _vm.max },
        domProps: { value: _vm.value },
        on: { input: _vm.onInput },
      }),
      _vm._v(" "),
      _vm.hasDisabledTrack
        ? _c("div", { staticClass: "ds-range-slider__track" })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.scaleItems && _vm.scaleItems.length > 0
      ? _c(
          "ul",
          { staticClass: "ds-range-slider__scale" },
          _vm._l(_vm.scaleItems, function (scaleItem, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "ds-range-slider__scale-item",
                class: {
                  "ds-range-slider__scale-item--active":
                    !_vm.isDisabledScaleItem(index) && index < _vm.value,
                  "ds-range-slider__scale-item--first": index === 0,
                  "ds-range-slider__scale-item--last":
                    index === _vm.scaleItems.length - 1,
                  "ds-range-slider__scale-item--disabled":
                    _vm.isDisabledScaleItem(index),
                },
              },
              [
                _c("span", { staticClass: "ds-range-slider__scale-label" }, [
                  scaleItem.icon
                    ? _c(
                        "i",
                        {
                          staticClass:
                            "chefkoch-icons ds-range-slider__scale-icon",
                          class: [
                            scaleItem.iconColor &&
                            !_vm.isDisabledScaleItem(index)
                              ? "ds-text-" + scaleItem.iconColor
                              : "",
                          ],
                        },
                        [_vm._v(_vm._s(scaleItem.icon))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  scaleItem.text
                    ? _c(
                        "span",
                        { staticClass: "ds-range-slider__scale-text" },
                        [_vm._v(_vm._s(scaleItem.text))]
                      )
                    : _vm._e(),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;

  /* style */
  const __vue_inject_styles__$h = undefined;
  /* scoped */
  const __vue_scope_id__$h = undefined;
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$h = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    undefined,
    undefined,
    undefined
  );

var script$g = defineComponent({
    name: "DsRecipeMeta",
    props: {
        difficulty: {
            type: Number,
            enum: [0, 1, 2, 3],
            required: false
        },
        ingredientCount: {
            type: Number,
            required: false,
        },
        preparationTime: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const diffcultyName = computed(() => getNameForDifficulty(props.difficulty));
        const preparationTimeFormatted = computed(() => {
            if (!props.preparationTime || props.preparationTime === 0) {
                return '---';
            }
            return `${props.preparationTime} Min.`;
        });
        const ingredientsTextFormatted = computed(() => {
            return `${props.ingredientCount} Zutat${props.ingredientCount !== 1 ? 'en' : ''}`;
        });
        return {
            diffcultyName,
            ingredientsTextFormatted,
            preparationTimeFormatted
        };
    },
});

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "ds-recipe-info" },
    [
      _c(
        "i",
        {
          staticClass: "chefkoch-icons ds-recipe-info__icon",
          attrs: { "aria-hidden": "true" },
        },
        [_vm._v("")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "ds-recipe-info__text" }, [
        _vm._v(_vm._s(_vm.preparationTimeFormatted)),
      ]),
      _vm._v(" "),
      typeof _vm.ingredientCount !== "undefined" && _vm.ingredientCount > -1
        ? [
            _c(
              "i",
              {
                staticClass:
                  "chefkoch-icons ds-recipe-info__icon ds-recipe-info__icon--ml",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "ds-recipe-info__text" }, [
              _vm._v(_vm._s(_vm.ingredientsTextFormatted)),
            ]),
          ]
        : [
            _c(
              "i",
              {
                staticClass:
                  "chefkoch-icons ds-recipe-info__icon ds-recipe-info__icon--ml",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "ds-recipe-info__text" }, [
              _vm._v(_vm._s(_vm.diffcultyName)),
            ]),
          ],
    ],
    2
  )
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

  /* style */
  const __vue_inject_styles__$g = undefined;
  /* scoped */
  const __vue_scope_id__$g = undefined;
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    undefined,
    undefined,
    undefined
  );

var script$f = defineComponent({
    name: "DsRecipeRating",
    props: {
        rating: {
            type: Number,
            required: true,
        },
        numVotes: {
            type: Number,
            required: true,
        }
    },
    setup(props) {
        const iconClasses = computed(() => {
            return `${props.numVotes === 0 ? `ds-text-pepper` : `ds-text-mirabelle-dark`}`;
        });
        const icon = computed(() => {
            if (props.rating < 1.5 || props.numVotes === 0) {
                return '&#xe93e;';
            }
            if (props.rating < 4) {
                return '&#xe93d;';
            }
            return '&#xe93c;';
        });
        const countClasses = computed(() => {
            return `${props.numVotes > 0 ? `ds-recipe-info__text--ml` : ''}`;
        });
        const formattedRating = computed(() => {
            if (!isNaN(props.rating)) {
                return (Math.round(props.rating * 10) / 10).toString().replace('.', ',');
            }
            return '';
        });
        return {
            icon,
            iconClasses,
            formattedRating,
            countClasses
        };
    },
});

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "ds-recipe-info" }, [
    _c("i", {
      staticClass: "chefkoch-icons ds-recipe-info__icon",
      class: _vm.iconClasses,
      attrs: { "aria-hidden": "true" },
      domProps: { innerHTML: _vm._s(_vm.icon) },
    }),
    _vm._v(" "),
    _vm.numVotes > 0
      ? _c("span", { staticClass: "ds-recipe-info__text ds-text-semi-bold" }, [
          _c("span", { staticClass: "ds-sr-only" }, [
            _vm._v("Durchschnittliche Bewertung: "),
          ]),
          _vm._v(_vm._s(_vm.formattedRating)),
          _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("/")]),
          _c("span", { staticClass: "ds-sr-only" }, [_vm._v(" von ")]),
          _vm._v("5"),
          _c("span", { staticClass: "ds-sr-only" }, [_vm._v(" Sternen")]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "ds-recipe-info__text", class: _vm.countClasses },
      [
        _vm._v("(" + _vm._s(_vm.numVotes)),
        _c("span", { staticClass: "ds-sr-only" }, [_vm._v(" Bewertungen")]),
        _vm._v(")"),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;

  /* style */
  const __vue_inject_styles__$f = undefined;
  /* scoped */
  const __vue_scope_id__$f = undefined;
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    undefined,
    undefined,
    undefined
  );

var script$e = defineComponent({
    name: "DsTextToggle",
    props: {
        isSaved: {
            type: Boolean,
            required: false,
            default: false,
        },
        animate: {
            type: Boolean,
            default: true,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: ['onClick'],
    setup(props, { emit }) {
        const animateSave = ref(!props.isSaved);
        const animationClasses = computed(() => {
            if (props.animate && props.isSaved && animateSave.value) {
                return `ds-animate ds-animate--pulse`;
            }
            return '';
        });
        const onClick = (event) => {
            event.preventDefault();
            emit('onClick', event);
        };
        watch(() => props.isSaved, (_value, oldValue) => {
            if (oldValue === false) {
                animateSave.value = true;
            }
        });
        return {
            animationClasses,
            onClick,
        };
    },
});

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass: "ds-btn ds-btn--round ds-btn--save",
      class: { "ds-btn--disabled": _vm.disabled },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _c(
        "i",
        {
          staticClass: "chefkoch-icons ds-btn__icon",
          class: _vm.animationClasses,
        },
        [_vm.isSaved ? [_vm._v("")] : [_vm._v("")]],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

  /* style */
  const __vue_inject_styles__$e = undefined;
  /* scoped */
  const __vue_scope_id__$e = undefined;
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    undefined,
    undefined,
    undefined
  );

var script$d = defineComponent({
    name: "DsRecipeCard",
    components: {
        DsAuthor: __vue_component__$J,
        DsPlusBadge: __vue_component__$L,
        DsRecipeMeta: __vue_component__$g,
        DsRecipeRating: __vue_component__$f,
        DsResponsiveImage: __vue_component__$z,
        DsSaveButton: __vue_component__$e,
        DsTextToggle: __vue_component__$x
    },
    props: {
        authorAvatarUrl: {
            type: String,
            required: false,
        },
        authorIsVerified: {
            type: Boolean,
            required: false,
        },
        authorName: {
            type: String,
            required: false,
        },
        brandImage: {
            type: String,
            required: false
        },
        category: {
            type: String,
            required: false,
        },
        gridCols: {
            type: Number,
            default: 6,
        },
        gridM: {
            type: Number,
            default: 3,
        },
        gridS: {
            type: Number,
            default: 4,
        },
        description: {
            type: String,
            required: false,
        },
        difficulty: {
            type: Number,
            enum: [0, 1, 2, 3],
            required: false
        },
        hasImage: {
            type: Boolean,
            required: true,
        },
        hasMultiselect: {
            type: Boolean,
            required: false,
            default: false
        },
        hasSaveButton: {
            type: Boolean,
            required: false,
            default: false
        },
        imageTemplate: {
            type: String,
            required: true
        },
        ingredientCount: {
            type: Number,
            required: false
        },
        isPlus: {
            type: Boolean,
            required: false,
            default: false
        },
        isPrivate: {
            type: Boolean,
            required: false,
            default: false
        },
        isSaved: {
            type: Boolean,
            required: false,
            default: false
        },
        isSelected: {
            type: Boolean,
            required: false,
            default: false
        },
        linkTitle: {
            type: String,
            required: false
        },
        note: {
            type: String,
            required: false
        },
        numVotes: {
            type: Number,
            required: false,
        },
        preparationTime: {
            type: Number,
            required: false,
        },
        rating: {
            type: Number,
            required: false,
        },
        siteUrl: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: true,
        },
    },
    emits: ['onClick', 'onSaveButtonClick', 'onSelect'],
    setup(props, { emit }) {
        const { linkTag, linkTitleFormatted, showRating, privateBadgeClass } = useRecipeInfo(props);
        const linkClasses = computed(() => {
            return `ds-recipe-card__link${props.siteUrl ? ' ds-teaser-link' : ''}`;
        });
        const onClick = (event) => {
            emit('onClick', event);
        };
        const onSaveButtonClick = (event) => {
            emit('onSaveButtonClick', event);
        };
        const onSelect = (event) => {
            emit('onSelect', event);
        };
        return {
            linkClasses,
            linkTag,
            linkTitleFormatted,
            onClick,
            onSaveButtonClick,
            onSelect,
            privateBadgeClass,
            showRating
        };
    },
});

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "ds-recipe-card" },
    [
      _c(
        _vm.linkTag,
        {
          tag: "component",
          class: _vm.linkClasses,
          attrs: {
            href: !!_vm.siteUrl ? _vm.siteUrl : null,
            title: !!_vm.siteUrl ? _vm.linkTitleFormatted : null,
          },
          on: {
            click: function ($event) {
              return _vm.onClick($event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "ds-recipe-card__image-wrap ds-teaser-link__image-wrap",
              class: { "ds-teaser-link__image-wrap": _vm.hasImage },
            },
            [
              _vm.hasImage && _vm.imageTemplate
                ? _c("ds-responsive-image", {
                    class: "ds-teaser-link__image",
                    attrs: {
                      aspectRatio: "4x5",
                      imageTemplate: _vm.imageTemplate,
                      cols: _vm.gridCols,
                      s: _vm.gridS,
                      m: _vm.gridM,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.brandImage
            ? _c("div", { staticClass: "ds-recipe-card__logo-wrap" }, [
                _c("img", {
                  staticClass: "ds-recipe-card__logo",
                  attrs: { height: "64", src: _vm.brandImage },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.category
            ? _c("div", { staticClass: "ds-recipe-card__category" }, [
                _c("span", { staticClass: "ds-text-category" }, [
                  _vm._v(_vm._s(_vm.category)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showRating
            ? _c(
                "div",
                { staticClass: "ds-recipe-card__rating" },
                [
                  _c("ds-recipe-rating", {
                    attrs: { rating: _vm.rating, numVotes: _vm.numVotes },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "h3",
            {
              staticClass:
                "ds-h4 ds-recipe-card__headline ds-teaser-link__headline ds-trunc ds-trunc-3 ds-text-sans",
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _vm._v(" "),
          _vm.difficulty
            ? _c(
                "div",
                { staticClass: "ds-recipe-card__meta" },
                [
                  _c("ds-recipe-meta", {
                    attrs: {
                      difficulty: _vm.difficulty,
                      ingredientCount: _vm.ingredientCount,
                      preparationTime: _vm.preparationTime,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.description
            ? _c(
                "div",
                {
                  staticClass:
                    "ds-recipe-card__description ds-text-caption ds-trunc ds-trunc-2",
                },
                [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authorName
            ? _c(
                "div",
                { staticClass: "ds-recipe-card__author" },
                [
                  _c("ds-author", {
                    attrs: {
                      name: _vm.authorName,
                      isVerified: _vm.authorIsVerified,
                      avatarUrl: _vm.authorAvatarUrl,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.descriptionBelow
            ? [
                _c(
                  "div",
                  {
                    staticClass: "ds-recipe-card__description ds-text-caption",
                  },
                  [_vm._t("descriptionBelow")],
                  2
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isPrivate || _vm.isPlus
            ? _c(
                "div",
                {
                  staticClass:
                    "ds-recipe-card__action ds-recipe-card__action--left",
                  class: {
                    "ds-recipe-card__action--plus":
                      _vm.isPlus && !_vm.isPrivate,
                  },
                },
                [
                  _vm.isPlus && !_vm.isPrivate
                    ? _c("ds-plus-badge")
                    : _c(
                        "div",
                        {
                          staticClass: "ds-card-badge",
                          class: _vm.privateBadgeClass,
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "chefkoch-icons ds-card-badge__icon",
                            },
                            [_vm._v("")]
                          ),
                        ]
                      ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.$slots.menu
        ? [
            _c(
              "div",
              { staticClass: "ds-recipe-card__action" },
              [_vm._t("menu")],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.$slots.menu && (_vm.hasMultiselect || _vm.hasSaveButton)
        ? _c(
            "div",
            { staticClass: "ds-recipe-card__action" },
            [
              _vm.hasSaveButton
                ? [
                    _c("ds-save-button", {
                      attrs: { isSaved: _vm.isSaved },
                      on: { onClick: _vm.onSaveButtonClick },
                    }),
                  ]
                : [
                    _c(
                      "button",
                      {
                        staticClass:
                          "ds-recipe-card__button ds-btn ds-btn--round",
                        on: { click: _vm.onSelect },
                      },
                      [
                        _vm.isSelected
                          ? _c(
                              "i",
                              { staticClass: "chefkoch-icons ds-btn__icon" },
                              [_vm._v("")]
                            )
                          : _c(
                              "i",
                              { staticClass: "chefkoch-icons ds-btn__icon" },
                              [_vm._v("")]
                            ),
                      ]
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.note
        ? _c(
            "div",
            { staticClass: "ds-recipe-card__note" },
            [_c("ds-text-toggle", { attrs: { text: _vm.note } })],
            1
          )
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

  /* style */
  const __vue_inject_styles__$d = undefined;
  /* scoped */
  const __vue_scope_id__$d = undefined;
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    undefined,
    undefined,
    undefined
  );

const format2x = 'crop-288x216';
const format1x = 'crop-144x108';
var script$c = defineComponent({
    name: 'DsRecipeListItem',
    components: {
        DsAuthor: __vue_component__$J,
        DsPlusBadge: __vue_component__$L,
        DsRecipeMeta: __vue_component__$g,
        DsRecipeRating: __vue_component__$f,
        DsSaveButton: __vue_component__$e,
        DsTextToggle: __vue_component__$x,
    },
    props: {
        authorIsVerified: {
            type: Boolean,
            required: false,
        },
        authorName: {
            type: String,
            required: false,
        },
        difficulty: {
            type: Number,
            enum: [0, 1, 2, 3],
            required: true
        },
        hasImage: {
            type: Boolean,
            required: true,
        },
        hasSaveButton: {
            type: Boolean,
            required: false,
            default: false
        },
        imageTemplate: {
            type: String,
            required: true
        },
        inOverlay: {
            type: Boolean,
            required: false,
            default: false,
        },
        isPlus: {
            type: Boolean,
            required: false,
            default: false
        },
        isPrivate: {
            type: Boolean,
            required: false,
            default: false
        },
        isSaved: {
            type: Boolean,
            required: false,
            default: false
        },
        linkTitle: {
            type: String,
            required: false
        },
        note: {
            type: String,
            required: false
        },
        numVotes: {
            type: Number,
            required: false,
        },
        preparationTime: {
            type: Number,
            required: true,
        },
        rating: {
            type: Number,
            required: false,
        },
        siteUrl: {
            type: String,
            required: false,
        },
        solid: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
    },
    emits: ['onClick', 'onSaveButtonClick', 'onTextToggleClick'],
    setup(props, { emit }) {
        const classes = computed(() => `${props.solid ? 'ds-list-view-item--solid' : ''}
      ${props.inOverlay ? ' ds-list-view-item--dialog' : ''}
      ${props.siteUrl && !props.solid ? ' ds-list-view-item--hover-bg-from-m' : ''}`);
        const { linkTag, linkTitleFormatted, showRating, privateBadgeClass } = useRecipeInfo(props);
        const imgSrc = computed(() => {
            if (!props.imageTemplate) {
                return '';
            }
            return `${props.imageTemplate.replace('<format>', format1x)}`;
        });
        const imgSrcSet = computed(() => {
            if (!props.imageTemplate) {
                return '';
            }
            return `${props.imageTemplate.replace('<format>', format2x)} 2x, ${imgSrc.value} 1x`;
        });
        const onClick = (event) => {
            emit('onClick', event);
        };
        const onSaveButtonClick = (event) => {
            emit('onSaveButtonClick', event);
        };
        const onTextToggleClick = (event) => {
            event.stopPropagation();
        };
        const linkClasses = computed(() => {
            return `ds-list-view-item__link${props.siteUrl ? ' ds-teaser-link' : ''}`;
        });
        return {
            classes,
            imgSrcSet,
            imgSrc,
            linkClasses,
            linkTag,
            linkTitleFormatted,
            onClick,
            onSaveButtonClick,
            onTextToggleClick,
            privateBadgeClass,
            showRating,
        };
    }
});

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-list-view-item ds-list-view-item--recipe",
      class: _vm.classes,
    },
    [
      _c(
        _vm.linkTag,
        {
          tag: "component",
          class: _vm.linkClasses,
          attrs: {
            href: !!_vm.siteUrl ? _vm.siteUrl : null,
            title: !!_vm.siteUrl ? _vm.linkTitleFormatted : null,
          },
          on: {
            click: function ($event) {
              return _vm.onClick($event)
            },
          },
        },
        [
          _c("div", { staticClass: "ds-list-view-item__media" }, [
            _c(
              "div",
              {
                staticClass: "ds-list-view-item__image-wrap",
                class: {
                  "ds-list-view-item__image-wrap--no-image":
                    !_vm.hasImage || !_vm.imgSrc,
                },
              },
              [
                _vm.hasImage && _vm.imgSrc
                  ? _c("img", {
                      staticClass: "ds-list-view-item__image",
                      attrs: {
                        width: "144",
                        height: "108",
                        loading: "lazy",
                        srcset: _vm.imgSrcSet,
                        src: _vm.imgSrc,
                        alt: _vm.title,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPrivate || _vm.isPlus
                  ? _c(
                      "div",
                      {
                        staticClass: "ds-list-view-item__badge",
                        class: {
                          "ds-list-view-item__badge--centered": _vm.isPrivate,
                        },
                      },
                      [
                        _vm.isPlus && !_vm.isPrivate
                          ? _c("ds-plus-badge", {
                              attrs: { "mobile-small": true },
                            })
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "ds-card-badge ds-card-badge--mobile-small",
                                class: _vm.privateBadgeClass,
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "chefkoch-icons ds-card-badge__icon",
                                  },
                                  [_vm._v("")]
                                ),
                              ]
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ds-list-view-item__body" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "ds-list-view-item__column ds-list-view-item__column--info",
                  class: _vm.inOverlay ? "ds-list-view-item__column--full" : "",
                },
                [
                  _vm.showRating
                    ? _c(
                        "div",
                        { staticClass: "ds-list-view-item__rating" },
                        [
                          _c("ds-recipe-rating", {
                            attrs: {
                              rating: _vm.rating,
                              numVotes: _vm.numVotes,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "h4",
                    {
                      staticClass:
                        "ds-teaser-link__headline ds-list-view-item__headline ds-h4 ds-text-sans ds-trunc ds-trunc-2",
                    },
                    [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _c("ds-recipe-meta", {
                    attrs: {
                      difficulty: _vm.difficulty,
                      preparationTime: _vm.preparationTime,
                    },
                  }),
                  _vm._v(" "),
                  _vm.authorName
                    ? _c(
                        "div",
                        { staticClass: "ds-list-view-item__author" },
                        [
                          _c("ds-author", {
                            attrs: {
                              name: _vm.authorName,
                              isVerified: _vm.authorIsVerified,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$slots.note
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ds-list-view-item__column ds-list-view-item__column--note",
                        class: _vm.inOverlay
                          ? "ds-list-view-item__column--full"
                          : "",
                      },
                      [_vm._t("note")],
                      2
                    ),
                  ]
                : [
                    _vm.note
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ds-list-view-item__column ds-list-view-item__column--note",
                            class: _vm.inOverlay
                              ? "ds-list-view-item__column--full"
                              : "",
                          },
                          [
                            _c("ds-text-toggle", {
                              attrs: { text: _vm.note },
                              on: { onClick: _vm.onTextToggleClick },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.$slots.menu
        ? [
            _c(
              "div",
              { staticClass: "ds-list-view-item__action" },
              [_vm._t("menu")],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.$slots.menu && _vm.hasSaveButton
        ? _c(
            "div",
            { staticClass: "ds-list-view-item__action" },
            [
              _c("ds-save-button", {
                attrs: { isSaved: _vm.isSaved },
                on: { onClick: _vm.onSaveButtonClick },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

  /* style */
  const __vue_inject_styles__$c = undefined;
  /* scoped */
  const __vue_scope_id__$c = undefined;
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    undefined,
    undefined,
    undefined
  );

var script$b = defineComponent({
    name: "DsSearchBar",
    components: {
        DsButton: __vue_component__$H,
        DsHorizontalScroll: __vue_component__$p,
        DsInputChip: __vue_component__$m
    },
    props: {
        autocompleteValue: {
            type: String,
        },
        submitButtonLabel: {
            type: String,
        },
        chips: {
            type: Array
        },
        chipsPosition: {
            type: String,
            enum: ['inside', 'outside'],
            default: 'inside',
        },
        errorMsg: {
            type: String,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        hasFocus: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: String,
        },
        iconPrepend: {
            type: String,
            default: '',
        },
        maxSuggestionItemsVisible: {
            type: Number,
            default: 6,
        },
        placeholder: {
            type: String,
        },
        showNoResults: {
            type: Boolean,
            default: false,
        },
        suggestions: {
            type: Array,
            required: false,
        },
        noResultsText: {
            type: String,
            required: false,
        }
    },
    emits: ['onArrowDown', 'onArrowUp', 'onBackdropClick', 'onBlur', 'onClearClick', 'onDelete', 'onChipClick', 'onEnter', 'onEscape', 'onFocus', 'onInput', 'onSubmitButtonClick', 'onSuggestionClick'],
    setup(props, { emit, slots }) {
        const value = ref(props.initialValue);
        const computedChips = ref(props.chips);
        const savedValue = ref('');
        const selectedSuggestion = ref(-1);
        const trackChanges = ref(false);
        const hasFocus = ref(false);
        const suggestRef = ref();
        const isAutosuggestVisible = ref(false);
        const inputRef = ref();
        const autocompleteValueVisible = computed(() => {
            if (props.autocompleteValue && value.value && props.autocompleteValue.toLowerCase().startsWith(value.value.toLowerCase())) {
                const searchRegex = new RegExp(value.value, 'i');
                return props.autocompleteValue.replace(searchRegex, '');
            }
            return '';
        });
        const showAutosuggest = computed(() => {
            if (isAutosuggestVisible.value && (slots.suggestions || props.suggestions)) {
                return true;
            }
            return false;
        });
        const hasChips = (position) => {
            if ((slots['chips'] || (computedChips.value && computedChips.value.length > 0)) && props.chipsPosition === position) {
                return true;
            }
            return false;
        };
        const hasInsideChips = computed(() => {
            return hasChips('inside');
        });
        const hasOutsideChips = computed(() => {
            return hasChips('outside');
        });
        const isClearable = computed(() => {
            let isClearable = false;
            if (value.value && value.value.length > 0) {
                isClearable = true;
            }
            if (hasChips('inside')) {
                isClearable = true;
            }
            return isClearable;
        });
        const controlClasses = computed(() => {
            return `${props.iconPrepend ? 'ds-search-bar__control--icon-prepend' : ''}`;
        });
        const inputMinWidth = computed(() => {
            let width = props.placeholder && !props.initialValue ? 9 * props.placeholder.length : 80;
            return `--search-bar-input-min-width: ${width}px`;
        });
        const suggestStyles = computed(() => {
            return props.maxSuggestionItemsVisible && !props.showNoResults ? `--search-bar-max-items-visible: ${props.maxSuggestionItemsVisible}` : '';
        });
        const initiallyScrollRight = computed(() => {
            return hasChips('inside');
        });
        const { attachEscapeKeyHandler, removeEscapeKeyHandler } = useEscapeKey(() => {
            if (isAutosuggestVisible.value === true) {
                selectedSuggestion.value = -1;
                isAutosuggestVisible.value = false;
                emit('onEscape');
            }
        });
        const focus = () => {
            inputRef && inputRef.value && inputRef.value.focus();
        };
        const setValue = (newValue) => {
            value.value = newValue;
        };
        onMounted(() => {
            attachEscapeKeyHandler();
            if (props.hasFocus) {
                nextTick(() => {
                    focus();
                });
            }
        });
        onUnmounted(removeEscapeKeyHandler);
        const onBlur = (event) => {
            selectedSuggestion.value = -1;
            emit('onBlur', event);
        };
        const onDelete = (event) => {
            trackChanges.value = false;
            emit('onDelete', event);
        };
        const onClearClick = () => {
            value.value = "";
            if (props.chipsPosition === 'inside') {
                computedChips.value = [];
            }
            emit('onClearClick');
            focus();
        };
        const onChipClick = (event, id, index) => {
            if (computedChips.value && computedChips.value.length > 0) {
                computedChips.value.splice(index, 1);
            }
            emit('onChipClick', event, id);
        };
        const onBackdropClick = (event) => {
            selectedSuggestion.value = -1;
            if (isAutosuggestVisible.value === true) {
                isAutosuggestVisible.value = false;
            }
            emit('onBackdropClick', event);
        };
        const onKeyDown = (e) => {
            if (props.suggestions && props.suggestions.length > 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    trackChanges.value = true;
                    if (selectedSuggestion.value === props.suggestions.length - 1) {
                        selectedSuggestion.value = 0;
                    }
                    else if (selectedSuggestion.value < props.suggestions.length - 1) {
                        selectedSuggestion.value++;
                    }
                    emit('onArrowDown', selectedSuggestion.value);
                }
                if (e.key === 'ArrowUp') {
                    trackChanges.value = true;
                    e.preventDefault();
                    if (selectedSuggestion.value >= 0) {
                        selectedSuggestion.value--;
                    }
                    if (selectedSuggestion.value === -1) {
                        selectedSuggestion.value = props.suggestions.length - 1;
                    }
                    emit('onArrowUp', selectedSuggestion.value);
                }
            }
            if (slots.suggestions) {
                if (e.key === 'ArrowDown') {
                    emit('onArrowDown');
                }
                if (e.key === 'ArrowUp') {
                    emit('onArrowUp');
                }
            }
        };
        const onInput = (event) => {
            trackChanges.value = false;
            if (hasFocus.value === true) {
                isAutosuggestVisible.value = true;
            }
            value.value = event.target.value;
            emit('onInput', value.value);
        };
        const onFocus = (event) => {
            hasFocus.value = true;
            emit('onFocus', event);
        };
        const onInputClick = () => {
            if (hasFocus.value === true) {
                isAutosuggestVisible.value = true;
            }
        };
        const onEnter = (e) => {
            e.preventDefault();
            emit('onEnter', e);
        };
        const onSuggestionClick = (event, id) => {
            if (!(event.target instanceof HTMLAnchorElement) || !event.target.href || event.target.href === '#') {
                event.preventDefault();
            }
            emit('onSuggestionClick', id);
        };
        const onSubmitButtonClick = (e) => {
            emit('onSubmitButtonClick', e);
        };
        watch(() => [props.suggestions], async () => {
            if (!props.suggestions || props.suggestions.length === 1) {
                selectedSuggestion.value = -1;
            }
        });
        watch(selectedSuggestion, (selectedSuggestion, oldSuggestion) => {
            if (trackChanges.value) {
                if (oldSuggestion === -1 && selectedSuggestion > -1) {
                    savedValue.value = value.value || '';
                }
                if (oldSuggestion > -1 && selectedSuggestion === -1) {
                    value.value = savedValue.value;
                    emit('onInput', value.value);
                }
                if (selectedSuggestion > -1 && props.suggestions) {
                    const selectedValue = props.suggestions[selectedSuggestion];
                    value.value = selectedValue.label;
                    emit('onInput', value.value);
                }
            }
        });
        return {
            autocompleteValueVisible,
            computedChips,
            controlClasses,
            focus,
            hasInsideChips,
            hasOutsideChips,
            initiallyScrollRight,
            inputMinWidth,
            inputRef,
            isAutosuggestVisible,
            isClearable,
            onBackdropClick,
            onBlur,
            onChipClick,
            onClearClick,
            onDelete,
            onEnter,
            onFocus,
            onInput,
            onInputClick,
            onKeyDown,
            onSubmitButtonClick,
            onSuggestionClick,
            selectedSuggestion,
            setValue,
            showAutosuggest,
            suggestRef,
            suggestStyles,
            value
        };
    },
});

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-search-bar",
      class: {
        "ds-search-bar--clearable": _vm.isClearable,
        "ds-search-bar--suggest-active": _vm.showAutosuggest,
        "ds-search-bar--error": _vm.hasError,
      },
    },
    [
      _c("div", { staticClass: "ds-search-bar__control-container" }, [
        _c(
          "div",
          { staticClass: "ds-search-bar__control", class: _vm.controlClasses },
          [
            _vm.iconPrepend
              ? _c("span", { staticClass: "ds-search-bar__control-icon" }, [
                  _c("i", { staticClass: "chefkoch-icons" }, [
                    _vm._v(_vm._s(_vm.iconPrepend)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ds-search-bar__control-scroll" },
              [
                _c(
                  "DsHorizontalScroll",
                  {
                    attrs: {
                      disableGradient: !_vm.hasInsideChips,
                      initiallyScrollRight: _vm.initiallyScrollRight,
                    },
                  },
                  [
                    _vm.hasInsideChips
                      ? _c(
                          "div",
                          { staticClass: "ds-search-bar__chips" },
                          [
                            _vm._t("chips"),
                            _vm._v(" "),
                            !_vm.$slots.chips
                              ? _vm._l(
                                  _vm.computedChips,
                                  function (chip, index) {
                                    return _c(
                                      "span",
                                      {
                                        key: index,
                                        staticClass:
                                          "ds-search-bar__control-chip",
                                      },
                                      [
                                        _c("DsInputChip", {
                                          attrs: {
                                            label: chip.label,
                                            id: chip.id,
                                          },
                                          on: {
                                            onClick: function ($event) {
                                              return _vm.onChipClick(
                                                $event,
                                                chip.id,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "ds-search-bar__control-input",
                        style: _vm.placeholder ? _vm.inputMinWidth : false,
                      },
                      [
                        _vm.autocompleteValue && _vm.value
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "ds-search-bar__input ds-search-bar__input--autocomplete",
                              },
                              [
                                _c("span", [_vm._v(_vm._s(_vm.value))]),
                                _vm._v(_vm._s(_vm.autocompleteValueVisible)),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("input", {
                          ref: "inputRef",
                          staticClass: "ds-search-bar__input",
                          attrs: {
                            type: "search",
                            enterkeyhint: "search",
                            name: "search-bar",
                            id: "search-bar",
                            placeholder: _vm.placeholder,
                            autocomplete: "off",
                          },
                          domProps: { value: _vm.value },
                          on: {
                            input: _vm.onInput,
                            focus: function ($event) {
                              return _vm.onFocus($event)
                            },
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onEnter.apply(null, arguments)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "delete",
                                    [8, 46],
                                    $event.key,
                                    ["Backspace", "Delete", "Del"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onDelete.apply(null, arguments)
                              },
                              _vm.onKeyDown,
                            ],
                            blur: _vm.onBlur,
                            click: _vm.onInputClick,
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ds-search-bar__clear-btn",
                on: { click: _vm.onClearClick },
              },
              [_c("i", { staticClass: "chefkoch-icons" }, [_vm._v("")])]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.hasError && _vm.errorMsg
          ? _c("div", { staticClass: "ds-search-bar__error-msg" }, [
              _vm._v(_vm._s(_vm.errorMsg)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasOutsideChips
          ? _c(
              "div",
              {
                staticClass:
                  "ds-search-bar__chips ds-search-bar__chips--outside",
              },
              [
                _vm._t("chips"),
                _vm._v(" "),
                !_vm.$slots.chips
                  ? _vm._l(_vm.computedChips, function (chip, index) {
                      return _c(
                        "span",
                        {
                          key: index,
                          staticClass: "ds-search-bar__control-chip",
                        },
                        [
                          _c("DsInputChip", {
                            attrs: { label: chip.label, id: chip.id },
                            on: {
                              onClick: function ($event) {
                                return _vm.onChipClick($event, chip.id, index)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    })
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "suggestRef",
            staticClass: "ds-search-bar__suggest",
            style: _vm.suggestStyles,
          },
          [
            _c(
              "div",
              { staticClass: "ds-search-bar__suggest-inner" },
              [
                _vm.showNoResults && _vm.noResultsText
                  ? _c("div", { staticClass: "ds-search-bar__suggest-empty" }, [
                      _vm._v(_vm._s(_vm.noResultsText)),
                    ])
                  : [
                      _vm._t("suggestions"),
                      _vm._v(" "),
                      !_vm.$slots.suggestions
                        ? _vm._l(_vm.suggestions, function (suggestion, index) {
                            return _c("div", {
                              key: index,
                              staticClass: "ds-search-bar__suggest-item",
                              class: {
                                "ds-search-bar__suggest-item--active":
                                  _vm.selectedSuggestion === index,
                              },
                              attrs: { tabindex: "-1" },
                              domProps: {
                                innerHTML: _vm._s(suggestion.labelHighlighted),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onSuggestionClick(
                                    $event,
                                    suggestion.id
                                  )
                                },
                              },
                            })
                          })
                        : _vm._e(),
                    ],
              ],
              2
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "ds-search-bar__backdrop",
        on: {
          click: function ($event) {
            return _vm.onBackdropClick($event)
          },
        },
      }),
      _vm._v(" "),
      _vm.submitButtonLabel || _vm.$slots.submitButton
        ? _c(
            "div",
            { staticClass: "ds-search-bar__btn" },
            [
              _vm.$slots.submitButton
                ? [_vm._t("submitButton")]
                : _c("ds-button", {
                    attrs: { mode: "primary", label: _vm.submitButtonLabel },
                    on: { onClick: _vm.onSubmitButtonClick },
                  }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

  /* style */
  const __vue_inject_styles__$b = undefined;
  /* scoped */
  const __vue_scope_id__$b = undefined;
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    undefined,
    undefined,
    undefined
  );

var script$a = defineComponent({
    name: "DsSelect",
    components: { DsFormItem: __vue_component__$C },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        errorMsg: {
            type: String,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        hint: {
            type: String,
        },
        id: {
            type: String,
        },
        initialValue: {
            type: [Number, String],
        },
        label: {
            type: String,
        },
        labelIcon: {
            type: String,
        },
        name: {
            type: String,
        },
        options: {
            type: Array,
        },
    },
    emits: ['onChange'],
    setup(props, { emit }) {
        const inputRef = ref();
        const { computedId } = useComputedId(props);
        const onChange = (event) => {
            emit('onChange', computedId.value, event.target.value);
        };
        return {
            computedId,
            inputRef,
            onChange,
        };
    }
});

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "DsFormItem",
    {
      attrs: {
        errorMsg: _vm.hasError && _vm.errorMsg ? _vm.errorMsg : null,
        hint: _vm.hint,
        id: _vm.computedId,
        label: _vm.label,
        labelIcon: _vm.labelIcon,
      },
    },
    [
      _c("div", { staticClass: "ds-select" }, [
        _c(
          "select",
          {
            ref: "inputRef",
            staticClass: "ds-select__control",
            class: { "ds-select__control--error": _vm.hasError },
            attrs: {
              disabled: _vm.disabled,
              id: _vm.computedId,
              name: _vm.name || _vm.computedId,
            },
            on: { change: _vm.onChange },
          },
          _vm._l(_vm.options, function (option) {
            return _c(
              "option",
              {
                key: option.name,
                domProps: {
                  value: option.value,
                  selected: option.value === _vm.initialValue,
                },
              },
              [_vm._v(_vm._s(option.label))]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("i", { staticClass: "chefkoch-icons ds-select__icon" }, [
          _vm._v(""),
        ]),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;

  /* style */
  const __vue_inject_styles__$a = undefined;
  /* scoped */
  const __vue_scope_id__$a = undefined;
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    undefined,
    undefined,
    undefined
  );

var script$9 = defineComponent({
    name: "DsSlimFooter",
});

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  _vm._self._c || _h;
  return _vm._m(0)
};
var __vue_staticRenderFns__$9 = [
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("footer", { staticClass: "ds-slim-footer" }, [
      _c("div", { staticClass: "ds-container" }, [
        _c("div", { staticClass: "ds-col-12" }, [
          _c(
            "nav",
            {
              staticClass: "ds-slim-footer__nav",
              attrs: { "aria-label": "Footer Links" },
            },
            [
              _c("ul", { staticClass: "ds-slim-footer__nav-links" }, [
                _c("li", { staticClass: "ds-slim-footer__nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "ds-slim-footer__nav-link",
                      attrs: { href: "https://www.chefkoch.de/impressum.php" },
                    },
                    [_vm._v("\n              Impressum\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "ds-slim-footer__nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "ds-slim-footer__nav-link",
                      attrs: {
                        href: "https://www.chefkoch.de/magazin/datenschutz.html",
                      },
                    },
                    [_vm._v("\n              Datenschutz\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass:
                      "ds-slim-footer__nav-item consent--privacy-manager",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "ds-slim-footer__nav-link",
                        attrs: {
                          href: "https://www.chefkoch.de/magazin/datenschutz.html#consent-management-mit-sourcepoint",
                        },
                      },
                      [
                        _vm._v(
                          "\n              Datenschutz-Einstellungen\n            "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "ds-slim-footer__nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "ds-slim-footer__nav-link",
                      attrs: {
                        href: "https://kundenservice.chefkoch.de/hc/de/requests/new?ticket_form_id=4536290816924",
                      },
                    },
                    [_vm._v("\n              Verträge kündigen\n            ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ])
  },
];
__vue_render__$9._withStripped = true;

  /* style */
  const __vue_inject_styles__$9 = undefined;
  /* scoped */
  const __vue_scope_id__$9 = undefined;
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    undefined,
    undefined,
    undefined
  );

var script$8 = defineComponent({
    name: "DsSnackbar",
    components: {
        DsInlineNotification: __vue_component__$n
    },
    props: {
        autoClose: {
            type: Boolean,
            default: true,
        },
        buttonLabel: String,
        closable: {
            type: Boolean,
            default: true,
        },
        copy: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true
        },
        mode: {
            type: String,
            enum: [
                'info',
                'success',
                'warning',
                'danger',
            ],
            default: 'info'
        },
    },
    emits: ['onButtonClick', 'onClose'],
    setup(props, { emit }) {
        const onButtonClick = () => {
            emit("onButtonClick");
        };
        const close = () => {
            emit("onClose");
        };
        const onClose = () => {
            close();
        };
        onMounted(() => {
            if (props.autoClose || !props.closable) {
                setTimeout(close, 8000);
            }
        });
        return {
            onButtonClick,
            onClose,
        };
    }
});

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "DsInlineNotification",
    _vm._b(
      {
        ref: "snackbarRef",
        class: "ds-notification--snackbar",
        on: { onClose: _vm.onClose, onButtonClick: _vm.onButtonClick },
      },
      "DsInlineNotification",
      _vm.$props,
      false
    )
  )
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

var script$7 = defineComponent({
    name: "DsSnackbarContainer",
    components: {
        DsSnackbar: __vue_component__$8
    },
    setup() {
        const { removeSnackbar, snackbars } = useSnackbar();
        const visibleSnackbars = computed(() => {
            const visible = [];
            if (snackbars.value.length > 0) {
                visible.push(snackbars.value[snackbars.value.length - 1]);
            }
            return visible;
        });
        const onBeforeLeave = (el) => {
            if (snackbars.value.length > 1) {
                el.classList.add('fast');
            }
        };
        const onAfterLeave = (el) => {
            removeSnackbar(el.id);
        };
        return {
            onAfterLeave,
            onBeforeLeave,
            removeSnackbar,
            snackbars,
            visibleSnackbars
        };
    }
});

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "TransitionGroup",
    {
      staticClass: "ds-snackbar-container",
      attrs: { name: "ds-snackbar-slide", tag: "div" },
      on: {
        "before-leave": _vm.onBeforeLeave,
        "after-leave": _vm.onAfterLeave,
      },
    },
    _vm._l(_vm.visibleSnackbars, function (snackbar) {
      return _c(
        "DsSnackbar",
        _vm._g(
          {
            key: snackbar.id,
            attrs: {
              autoClose: snackbar.autoClose,
              buttonLabel: snackbar.buttonLabel,
              closable: snackbar.closable,
              copy: snackbar.copy,
              id: snackbar.id,
              mode: snackbar.mode,
            },
            on: {
              onClose: function () {
                _vm.removeSnackbar(snackbar.id);
              },
            },
          },
          snackbar.onButtonClick
            ? { onButtonClick: snackbar.onButtonClick }
            : {}
        )
      )
    }),
    1
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = function (inject) {
    if (!inject) return
    inject("data-v-12e6cbf5_0", { source: "\n.ds-snackbar-slide-enter,\n.ds-snackbar-slide-enter-active {\n    animation: ds-snackbar-slide-in 0.25s;\n}\n.ds-snackbar-slide-leave-active {\n    animation: ds-snackbar-slide-in 0.25s reverse;\n}\n.ds-snackbar-slide-leave-active.fast {\n  animation-duration: 0.05s;\n}\n@keyframes ds-snackbar-slide-in {\nfrom {\n        transform: scale(0.4);\n        visibility: visible;\n        opacity: 0;\n}\nto {\n        transform: scale(1);\n        opacity: 1;\n}\n}\n@keyframes ds-snackbar-slide-out {\nfrom {\n        transform: scale(0.4);\n        visibility: visible;\n        opacity: 0;\n}\nto {\n        transform: scale(1);\n        opacity: 1;\n}\n}\n\n", map: {"version":3,"sources":["/builds/dev/dsy/packages/dsy-vue/src/components/DsSnackbarContainer/DsSnackbarContainer.vue"],"names":[],"mappings":";AAmEA;;IAEA,qCAAA;AACA;AAEA;IACA,6CAAA;AACA;AAEA;EACA,yBAAA;AACA;AAEA;AACA;QACA,qBAAA;QACA,mBAAA;QACA,UAAA;AACA;AAEA;QACA,mBAAA;QACA,UAAA;AACA;AACA;AAEA;AACA;QACA,qBAAA;QACA,mBAAA;QACA,UAAA;AACA;AAEA;QACA,mBAAA;QACA,UAAA;AACA;AACA","file":"DsSnackbarContainer.vue","sourcesContent":["<template>\n  <TransitionGroup name=\"ds-snackbar-slide\" class=\"ds-snackbar-container\" tag=\"div\" \n    @before-leave=\"onBeforeLeave\"\n    @after-leave=\"onAfterLeave\"\n  >\n    <DsSnackbar\n      v-for=\"(snackbar) in visibleSnackbars\"\n      :autoClose=\"snackbar.autoClose\"\n      :buttonLabel=\"snackbar.buttonLabel\"\n      :closable=\"snackbar.closable\"\n      :copy=\"snackbar.copy\" \n      :id=\"snackbar.id\" \n      :key=\"snackbar.id\" \n      :mode=\"snackbar.mode\"\n      v-on=\"snackbar.onButtonClick ? { onButtonClick: snackbar.onButtonClick }: {}\"\n      @onClose=\"() => {\n        removeSnackbar(snackbar.id);\n      }\"\n    />\n  </TransitionGroup>\n</template>\n\n<script lang=\"ts\">\nimport { computed, defineComponent } from \"@vue/composition-api\";\nimport { useSnackbar } from \"../../composables/useSnackbar\";\nimport DsSnackbar from '../DsSnackbar/DsSnackbar.vue';\n\nexport default defineComponent({\n  name: \"DsSnackbarContainer\",\n  components: {\n    DsSnackbar\n  },\n  setup() {\n    const { removeSnackbar, snackbars } = useSnackbar();\n\n    const visibleSnackbars = computed(() => {\n      const visible = [];\n\n      if(snackbars.value.length > 0) {\n        visible.push(snackbars.value[snackbars.value.length - 1]);\n      }\n\n      return visible;\n    });\n\n    const onBeforeLeave = (el: HTMLDivElement) => {\n      if(snackbars.value.length > 1) {\n        el.classList.add('fast');\n      }\n    }\n\n    const onAfterLeave = (el: HTMLDivElement) => {\n      removeSnackbar(el.id);\n    }\n\n    return {\n      onAfterLeave,\n      onBeforeLeave,\n      removeSnackbar,\n      snackbars,\n      visibleSnackbars\n    }\n  }\n});\n</script>\n\n<style>\n.ds-snackbar-slide-enter,\n.ds-snackbar-slide-enter-active {\n    animation: ds-snackbar-slide-in 0.25s;\n}\n\n.ds-snackbar-slide-leave-active {\n    animation: ds-snackbar-slide-in 0.25s reverse;\n}\n\n.ds-snackbar-slide-leave-active.fast {\n  animation-duration: 0.05s;\n}\n\n@keyframes ds-snackbar-slide-in {\n    from {\n        transform: scale(0.4);\n        visibility: visible;\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n@keyframes ds-snackbar-slide-out {\n    from {\n        transform: scale(0.4);\n        visibility: visible;\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n</style>"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    createInjector,
    undefined,
    undefined
  );

const baseUrl = 'https://img.chefkoch-cdn.de/assets/v2/img/ci/';
const imgInfos = {
    plus: {
        src: `${baseUrl}CK-Plus-basmati.svg`,
        alt: "Chefkoch PLUS"
    },
    pur: {
        src: `${baseUrl}CK-Pur-olive.svg`,
        alt: "Chefkoch PUR"
    },
    ck: {
        src: `${baseUrl}CK-Logo.svg`,
        alt: "Chefkoch"
    }
};
var script$6 = defineComponent({
    name: "DsSubscriptionCard",
    props: {
        type: {
            type: String,
            enum: ['plus', 'pur', 'ck'],
            required: true,
            default: 'plus'
        },
        bodyImageUrl: {
            type: String,
            required: false,
        },
        bodyImagePosition: {
            type: String,
            enum: ['top', 'bottom'],
            default: 'top'
        }
    },
    setup(props, { slots }) {
        const classes = computed(() => {
            return `ds-subscription-card--${props.type}${slots.footer ? '' : ' ds-subscription-card--no-footer'}`;
        });
        const imgAlt = computed(() => {
            return imgInfos[props.type].alt;
        });
        const imgSrc = computed(() => {
            return imgInfos[props.type].src;
        });
        return {
            classes,
            imgAlt,
            imgSrc,
        };
    },
});

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "ds-subscription-card", class: _vm.classes },
    [
      _c("div", { staticClass: "ds-subscription-card__head" }, [
        _c("img", {
          attrs: {
            height: "32",
            loading: "lazy",
            alt: _vm.imgAlt,
            src: _vm.imgSrc,
          },
        }),
      ]),
      _vm._v(" "),
      _vm.bodyImageUrl && _vm.bodyImagePosition === "top"
        ? _c("img", {
            staticClass: "ds-subscription-card__image",
            attrs: { src: _vm.bodyImageUrl },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ds-subscription-card__body" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.bodyImageUrl && _vm.bodyImagePosition === "bottom"
        ? _c("img", {
            staticClass: "ds-subscription-card__image",
            attrs: { src: _vm.bodyImageUrl },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.footer
        ? [
            _c(
              "div",
              { staticClass: "ds-subscription-card__footer" },
              [_vm._t("footer")],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = undefined;
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    undefined,
    undefined,
    undefined
  );

var script$5 = defineComponent({
    name: "DsSwitch",
    props: {
        checked: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        },
        hasError: {
            type: Boolean
        },
        id: {
            type: String,
        },
        label: {
            type: String
        },
        labelFirst: {
            type: Boolean
        },
        value: {
            type: [Number, String],
            required: true,
        }
    },
    emits: ['onChange'],
    setup(props, { emit }) {
        const { computedId } = useComputedId(props);
        const onChange = (e) => {
            emit('onChange', e.target.value, e.target.checked);
        };
        return {
            computedId,
            onChange
        };
    },
});

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-switch",
      class: { "ds-switch--label-first": _vm.labelFirst },
    },
    [
      _c("input", {
        staticClass: "ds-switch__input",
        attrs: {
          type: "checkbox",
          disabled: _vm.disabled,
          id: _vm.computedId,
          "aria-disabled": _vm.disabled,
        },
        domProps: { checked: _vm.checked, value: _vm.value },
        on: { change: _vm.onChange },
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "ds-switch__label", attrs: { for: _vm.computedId } },
        [_vm._v(_vm._s(_vm.label))]
      ),
    ]
  )
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

var script$4 = defineComponent({
    name: "DsTabNavigation",
    props: {
        ariaLabel: String,
    },
});

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("nav", { attrs: { "aria-label": _vm.ariaLabel } }, [
    _c("ul", { staticClass: "ds-tab-nav" }, [_vm._t("default")], 2),
  ])
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

var script$3 = defineComponent({
    name: "DsTabNavigationItem",
    props: {
        active: Boolean,
        disabled: Boolean,
        href: {
            type: String,
        },
        icon: String,
        label: {
            type: String,
            required: true,
        },
        plus: Boolean,
    },
    emits: ['onClick', 'onMouseLeave', 'onMouseOver'],
    setup(props, { emit }) {
        const linkTag = computed(() => {
            if (props.disabled) {
                return 'span';
            }
            if (!props.href) {
                return 'button';
            }
            return 'a';
        });
        const onClick = (e) => {
            emit('onClick', e);
        };
        const onMouseLeave = (e) => {
            emit('onMouseLeave', e);
        };
        const onMouseOver = (e) => {
            emit('onMouseOver', e);
        };
        return {
            linkTag,
            onClick,
            onMouseLeave,
            onMouseOver
        };
    }
});

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "li",
    { staticClass: "ds-tab-nav__item" },
    [
      _c(
        _vm.linkTag,
        {
          tag: "component",
          staticClass: "ds-tab-nav__link",
          class: {
            "ds-tab-nav__link--active": _vm.active,
            "ds-tab-nav__link--plus": _vm.plus,
            "ds-tab-nav__link--disabled": _vm.disabled,
          },
          attrs: { href: !_vm.disabled ? _vm.href : null },
          on: {
            click: _vm.onClick,
            mouseover: _vm.onMouseOver,
            mouseleave: _vm.onMouseLeave,
          },
        },
        [
          _vm.icon
            ? _c("i", { staticClass: "ds-tab-nav__link-icon chefkoch-icons" }, [
                _vm._v(_vm._s(_vm.icon)),
              ])
            : _vm._e(),
          _c("span", { staticClass: "ds-tab-nav__link-label" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._t("subItem"),
    ],
    2
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

var script$2 = defineComponent({
    name: "DsTextArea",
    components: { DsFormItem: __vue_component__$C },
    props: {
        autogrow: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        errorMsg: {
            type: String,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        hint: {
            type: String,
        },
        id: {
            type: String,
        },
        initialValue: {
            type: String,
        },
        label: {
            type: String,
        },
        labelIcon: {
            type: String,
        },
        maxLength: {
            type: Number,
        },
        name: {
            type: String,
        },
        placeholder: {
            type: String
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: Number,
            default: 4,
        },
    },
    emits: ['onBlur', 'onFocus', 'onInput'],
    setup(props, { emit }) {
        const computedValue = ref(props.initialValue);
        const inputRef = ref();
        const { computedId } = useComputedId(props);
        const onInput = (event) => {
            computedValue.value = event.target.value;
            emit('onInput', computedId.value, computedValue.value);
        };
        const onBlur = (event) => {
            emit('onBlur', event);
        };
        const onFocus = (event) => {
            emit('onFocus', event);
        };
        return {
            computedId,
            inputRef,
            onBlur,
            onFocus,
            onInput,
            computedValue,
        };
    }
});

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "DsFormItem",
    {
      attrs: {
        errorMsg: _vm.hasError && _vm.errorMsg ? _vm.errorMsg : null,
        hint: _vm.hint,
        id: _vm.computedId,
        label: _vm.label,
        labelIcon: _vm.labelIcon,
        maxLength: _vm.maxLength,
        value: _vm.computedValue,
      },
    },
    [
      _c(
        "div",
        {
          class: { "ds-input-autogrow": _vm.autogrow },
          attrs: {
            "data-input-value": _vm.autogrow ? _vm.computedValue : null,
          },
        },
        [
          _c("textarea", {
            ref: "inputRef",
            staticClass: "ds-input ds-input--textarea",
            class: { "ds-input--error": _vm.hasError },
            attrs: {
              disabled: _vm.disabled,
              id: _vm.computedId,
              maxlength: _vm.maxLength,
              name: _vm.name || _vm.computedId,
              placeholder: _vm.placeholder,
              rows: _vm.rows,
              readonly: _vm.readOnly,
            },
            domProps: { value: _vm.computedValue },
            on: { blur: _vm.onBlur, focus: _vm.onFocus, input: _vm.onInput },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1 = defineComponent({
    name: "DsTextInput",
    components: { DsFormItem: __vue_component__$C },
    props: {
        isClearable: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        errorMsg: {
            type: String,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        hint: {
            type: String,
        },
        id: {
            type: String,
        },
        initialValue: {
            type: [String, Number],
        },
        label: {
            type: String,
        },
        labelIcon: {
            type: String,
        },
        maxLength: {
            type: Number,
        },
        name: {
            type: String,
        },
        placeholder: {
            type: String
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "text",
        },
        unit: {
            type: String,
        },
    },
    emits: ['onBlur', 'onClearClick', 'onFocus', 'onInput'],
    setup(props, { emit }) {
        const computedValue = ref(props.initialValue);
        const inputRef = ref();
        const { computedId } = useComputedId(props);
        const inputContainerClasses = computed(() => {
            if (props.isClearable) {
                return 'ds-input-clearable';
            }
            if (props.unit) {
                return 'ds-input-group';
            }
            return "";
        });
        const focus = () => {
            inputRef && inputRef.value && inputRef.value.focus();
        };
        const onInput = (event) => {
            computedValue.value = event.target.value;
            emit('onInput', computedId.value, computedValue.value);
        };
        const onBlur = (event) => {
            emit('onBlur', event);
        };
        const onClearClick = () => {
            computedValue.value = "";
            emit('onClearClick', computedId.value);
            focus();
        };
        const onFocus = (event) => {
            emit('onFocus', event);
        };
        return {
            computedId,
            inputContainerClasses,
            inputRef,
            onBlur,
            onClearClick,
            onFocus,
            onInput,
            computedValue,
        };
    }
});

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "DsFormItem",
    {
      attrs: {
        errorMsg: _vm.hasError && _vm.errorMsg ? _vm.errorMsg : null,
        hint: _vm.hint,
        id: _vm.computedId,
        label: _vm.label,
        labelIcon: _vm.labelIcon,
        maxLength: _vm.maxLength,
        value: _vm.computedValue,
      },
    },
    [
      _c("div", { class: _vm.inputContainerClasses }, [
        _c("input", {
          ref: "inputRef",
          staticClass: "ds-input",
          class: {
            "ds-input--error": _vm.hasError,
            "ds-input-clearable__control": _vm.isClearable,
            "ds-input--appended ds-input-group__control":
              _vm.unit && !_vm.isClearable,
          },
          attrs: {
            name: _vm.name,
            id: _vm.computedId,
            type: _vm.type,
            disabled: _vm.disabled,
            placeholder: _vm.placeholder,
            maxlength: _vm.maxLength,
            readonly: _vm.readOnly,
          },
          domProps: { value: _vm.computedValue },
          on: { blur: _vm.onBlur, focus: _vm.onFocus, input: _vm.onInput },
        }),
        _vm._v(" "),
        _vm.isClearable && _vm.computedValue && !_vm.readOnly && !_vm.disabled
          ? _c(
              "button",
              {
                staticClass: "ds-input-clearable__btn",
                on: { click: _vm.onClearClick },
              },
              [_c("i", { staticClass: "chefkoch-icons" }, [_vm._v("")])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.unit && !_vm.isClearable
          ? _c(
              "span",
              {
                staticClass: "ds-input-group__append",
                class: { "ds-input--error": _vm.hasError },
              },
              [_vm._v(_vm._s(_vm.unit))]
            )
          : _vm._e(),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

var script = defineComponent({
    name: "DsToggleButton",
    props: {
        ariaLabel: String,
        name: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        }
    },
    emits: ['onChange'],
    setup(props, { emit }) {
        const onChange = (event) => {
            emit('onChange', event.target.value);
        };
        return {
            onChange,
        };
    },
});

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "ds-toggle-btn",
      attrs: {
        role: "group",
        "aria-labelledby": _vm.ariaLabel ? _vm.name + "-title" : null,
      },
    },
    [
      _vm.ariaLabel
        ? _c(
            "span",
            { staticClass: "ds-sr-only", attrs: { id: _vm.name + "-title" } },
            [_vm._v(_vm._s(_vm.ariaLabel))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function (option, idx) {
        return _c("div", { key: idx, staticClass: "ds-toggle-btn__option" }, [
          _c("input", {
            staticClass: "ds-toggle-btn__input",
            attrs: { type: "radio", name: _vm.name, id: _vm.name + "-" + idx },
            domProps: { value: option.value, checked: option.active },
            on: { change: _vm.onChange },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "ds-toggle-btn__label",
              attrs: { for: _vm.name + "-" + idx },
            },
            [
              option.icon
                ? _c(
                    "i",
                    { staticClass: "ds-toggle-btn__icon chefkoch-icons" },
                    [_vm._v(_vm._s(option.icon))]
                  )
                : _vm._e(),
              _vm._v(" "),
              option.label
                ? _c("span", { staticClass: "ds-toggle-btn__label-text" }, [
                    _vm._v(_vm._s(option.label)),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__$N as DsAccordion, __vue_component__$M as DsAccordionItem, __vue_component__$K as DsActionCard, __vue_component__$J as DsAuthor, __vue_component__$H as DsButton, __vue_component__$G as DsButtonBox, __vue_component__$D as DsCheckbox, __vue_component__$B as DsChoices, __vue_component__$A as DsChoicesItem, __vue_component__$F as DsCloseButton, __vue_component__$E as DsCoachMark, __vue_component__$y as DsCollectionCard, __vue_component__$w as DsCollectionListItem, __vue_component__$v as DsContextMenu, __vue_component__$u as DsDivider, __vue_component__$t as DsEggTimer, __vue_component__$s as DsFilterChip, __vue_component__$q as DsFullscreenOverlay, __vue_component__$p as DsHorizontalScroll, __vue_component__$o as DsInfobox, __vue_component__$n as DsInlineNotification, __vue_component__$m as DsInputChip, __vue_component__$I as DsLoader, __vue_component__$l as DsLoadingOverlay, __vue_component__$r as DsOverlay, __vue_component__$L as DsPlusBadge, __vue_component__$k as DsPromotionTeaser, __vue_component__$j as DsQuantityControl, __vue_component__$i as DsRadioButton, __vue_component__$h as DsRangeSlider, __vue_component__$d as DsRecipeCard, __vue_component__$c as DsRecipeListItem, __vue_component__$g as DsRecipeMeta, __vue_component__$f as DsRecipeRating, __vue_component__$z as DsResponsiveImage, __vue_component__$e as DsSaveButton, __vue_component__$b as DsSearchBar, __vue_component__$a as DsSelect, __vue_component__$9 as DsSlimFooter, __vue_component__$8 as DsSnackbar, __vue_component__$7 as DsSnackbarContainer, __vue_component__$6 as DsSubscriptionCard, __vue_component__$5 as DsSwitch, __vue_component__$4 as DsTabNavigation, __vue_component__$3 as DsTabNavigationItem, __vue_component__$2 as DsTextArea, __vue_component__$1 as DsTextInput, __vue_component__$x as DsTextToggle, __vue_component__ as DsToggleButton, formatNiceDate, getNameForDifficulty, hasDocument, hasWindow, highlightSuggestion, isUrl, noop, useClickOutside, useCollectionInfo, useComputedId, useEscapeKey, useRecipeInfo, useResponsiveImage, useScroll, useSnackbar, useWindowResize, uuid };
